/**
 * Laqqua GA4 Enrichment Layer v2.0
 *
 * ARCHITETTURA: Hybrid tracking
 * - Funnel ecommerce standard (page_view, view_item, add_to_cart, view_cart,
 *   remove_from_cart, begin_checkout, add_payment_info, purchase, search)
 *   → gestito dalla Google & YouTube channel app (Shopify nativo).
 *   Enhanced Measurement attivo per scroll/outbound/form/video/file/site search.
 * - Eventi custom + arricchiti → gestiti da QUESTO file.
 *
 * NON duplicare eventi standard GA4 gia' coperti dalla channel:
 *   • add_to_cart, view_item, begin_checkout sono rinominati in
 *     `add_to_cart_enriched`, `view_item_enriched`, `begin_checkout_enriched`
 *     per portare parametri custom (source, item_list_*, image_count, ecc.)
 *   • view_cart e remove_from_cart NON sono firati qui (la channel li gestisce).
 *   • item_id allineato alla channel: usa variant_id (non product_id).
 *
 * GA4 property: G-ENQG1D1M3F (stream "Laqqua Web")
 * Caricato DOPO snippets/cart-toast.liquid in layout/theme.liquid.
 * Si appende sopra il window.fetch gia' patchato dal cart-toast.
 */
(function () {
  'use strict';

  /* Guard double-load */
  if (window.__ga4TrackingLoaded) return;
  window.__ga4TrackingLoaded = true;

  var SCHEMA_VERSION = '2.3';

  /* ============================================================
     0. CORE: gtag, helpers, snapshot
     ============================================================ */

  if (typeof window.gtag !== 'function') {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
  }

  /* User_id + dev_theme flag impostati come parametri globali via gtag('set').
     Tutti gli eventi successivi li ereditano. */
  try {
    if (window.__laqquaCustomer && window.__laqquaCustomer.id) {
      window.gtag('set', { user_id: String(window.__laqquaCustomer.id) });
    }
  } catch (e) {}

  var isDevTheme = (location.search.indexOf('preview_theme_id=') !== -1) ||
                   (location.hostname.indexOf('myshopify.com') !== -1);
  /* ga_debug=1 e' l'alias usato in layout/theme.liquid: accettiamo entrambi. */
  var debugMode = location.search.indexOf("ga4debug") !== -1 ||
                  /[?&]ga_debug=1(&|$)/.test(location.search);

  /* ---- Traffico interno ------------------------------------------------
     isDevTheme vede solo l'anteprima tema e *.myshopify.com: NON vede chi
     lavora al sito e naviga laqqua.com da casa o da telefono. A ~50 sessioni
     al giorno quella quota falsa le metriche di navigazione, perche' chi
     costruisce il sito clicca i moduli molto piu' di un cliente vero.

     laqqua.com/?internal=1  marca questo device per sempre
     laqqua.com/?internal=0  lo smarca

     Alimenta traffic_type, l'unico campo che i Data filter di GA4 leggono
     (is_dev_theme da solo non serve a quello scopo). Il gtag('set') va DOPO
     il gtag('config') — che sta in layout/theme.liquid, caricato prima di
     questo file — e PRIMA del primo evento: questo e' il punto giusto.
     --------------------------------------------------------------------- */
  var INTERNAL_KEY = '__laqqua_internal';
  try {
    if (/[?&]internal=1(&|$)/.test(location.search)) localStorage.setItem(INTERNAL_KEY, '1');
    if (/[?&]internal=0(&|$)/.test(location.search)) localStorage.removeItem(INTERNAL_KEY);
  } catch (e) {}
  var isInternal = false;
  try { isInternal = localStorage.getItem(INTERNAL_KEY) === '1'; } catch (e) {}
  if (isDevTheme || isInternal) {
    try { window.gtag('set', { traffic_type: 'internal' }); } catch (e) {}
  }


  /* Eventi su cui si attacca last_click_nav (il "ponte" fra la strada di
     navigazione e cio' che succede dopo). Solo eventi NOSTRI: gli standard
     (view_item, add_to_cart, begin_checkout, purchase, page_view) li emette il
     Web Pixel della channel app Google & YouTube, in una sandbox che non
     possiamo toccare. Per questo il ponte vive sui gemelli *_enriched. */
  var EVENTI_CON_ATTRIBUZIONE = {
    view_item_enriched: 1,
    view_item_engaged: 1,
    view_item_list: 1,
    add_to_cart_enriched: 1,
    begin_checkout_enriched: 1
  };

  /* Gesti che qualificano una visita prodotto come "non rimbalzo". */
  var GESTI_PDP = {
    product_image_selected: 'gallery',
    product_tab_opened: 'tab',
    add_to_cart_enriched: 'atc'
  };

  function send(eventName, params) {
    try {
      var payload = Object.assign(
        { tracking_schema_version: SCHEMA_VERSION, is_dev_theme: isDevTheme },
        params || {}
      );
      if (EVENTI_CON_ATTRIBUZIONE[eventName]) {
        var lcn = getLastClickNav();
        if (lcn) payload.last_click_nav = lcn;
      }
      if (debugMode) { payload.debug_mode = true; }
      window.gtag('event', eventName, payload);
      if (GESTI_PDP[eventName]) segnalaGestoPdp(GESTI_PDP[eventName]);
    } catch (e) {}
  }

  /* Doppio invio: GA4 (meta' consenziente, ma agganciato all'ecommerce) e
     Umami (cookieless, traffico intero, conteggi esatti). Umami e' la fonte
     PRIMARIA delle metriche di modulo: a ~50 sessioni/giorno raddoppiare il
     campione vale piu' di qualunque raffinatezza statistica a valle. */
  function sendBoth(eventName, params) {
    send(eventName, params);
    try {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track(eventName, params || {});
      }
    } catch (e) {}
  }

  /* ------------------------------------------------------------------
     PONTE DI ATTRIBUZIONE — last_click_nav

     localStorage e non sessionStorage: sessionStorage e' per-tab, quindi il
     cmd+click su un riquadro (comportamento tipico di chi esplora un catalogo)
     aprirebbe una scheda con storage vuoto e perderebbe l'attribuzione.
     L'effetto collaterale (tab concorrenti che si sovrascrivono) e' proprio la
     semantica "last click" che vogliamo.

     Nessun TTL a tempo: alla lettura si confronta il session id GA4 corrente.
     Sessione diversa = valore morto. Coincidenza esatta con la sessione GA4
     per costruzione.
     ------------------------------------------------------------------ */
  var LCN_KEY = '__laqqua_lcn';

  function consensoAnalytics() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' &&
                cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  /* Session id GA4 letto dal cookie: SINCRONO e sempre aggiornato.
     gtag('get', ..., 'session_id', cb) e' asincrono e non si puo' usare dentro
     un click che sta per navigare; cacharlo al load si romperebbe se la
     sessione scade mentre l'utente e' sulla pagina.
     Copre entrambi i formati: GS1.1.<sid>.<n>...  e  GS2.1.s<sid>$o<n>$... */
  function ga4SessionId() {
    var m = document.cookie.match(/_ga_ENQG1D1M3F=GS\d\.\d\.s?(\d{8,})/);
    return m ? m[1] : '';
  }

  function setLastClickNav(valore) {
    /* Anche la SCRITTURA va dietro il consenso analytics, non solo l'invio:
       e' un accesso a storage, quindi ePrivacy. */
    if (!consensoAnalytics()) return;
    try {
      localStorage.setItem(LCN_KEY, JSON.stringify({
        v: String(valore).slice(0, 100),
        sid: ga4SessionId()
      }));
    } catch (e) {}
  }

  function getLastClickNav() {
    try {
      var raw = localStorage.getItem(LCN_KEY);
      if (!raw) return '';
      var o = JSON.parse(raw);
      if (!o || !o.v) return '';
      var sid = ga4SessionId();
      if (!sid || o.sid !== sid) return '';
      return o.v;
    } catch (e) { return ''; }
  }

  /* ------------------------------------------------------------------
     PONTE VERSO IL PURCHASE — identificativi GA4 sull'ordine

     Misurato il 2026-08-18 su 28 giorni: GA4 vede 79 dei 155 ordini web (51%),
     mentre vede l'85% delle sessioni. Non e' il consenso, e' un buco tecnico,
     ed e' cronico: il rapporto purchase/ordini e sceso da 68% a 52% in cinque
     mesi mentre la copertura sessioni restava ferma all'85%. Sono ~30% degli
     ordini invisibili, il che vuol dire che TUTTA l'attribuzione (canali,
     campagne e il nostro last_click_nav) e' costruita su meta' dei dati.

     Qui salviamo client_id e session_id GA4 come attributi del carrello, cosi'
     l'ordine se li porta dietro fino al webhook: da li' un Measurement Protocol
     lato server puo' ricostruire il purchase mancante — inclusi Shop Pay via
     shop.app, nuova scheda e cross-device, che nessuna soluzione client-side
     puo' coprire. Prefisso _ = attributo nascosto al cliente.

     Solo con consenso analytics: senza, gli attributi non esistono e l'invio
     server-side non parte. Conforme per costruzione, nessun consenso da
     re-implementare a valle.

     ⚠️ Questa meta' e' inerte finche' non esiste il consumatore lato server
     (webhook orders/create -> Edge Function -> MP). Ma va in produzione ORA:
     ogni giorno senza attributi e' un giorno di ordini non recuperabili.
     ------------------------------------------------------------------ */
  var carrelloMarcato = false;

  function marcaCarrelloConIdGa4() {
    if (carrelloMarcato) return;
    if (!consensoAnalytics()) return;
    var cid = (document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/) || [])[1] || '';
    var sid = ga4SessionId();
    if (!cid && !sid) return;
    carrelloMarcato = true;
    try {
      /* origFetch e' assegnata piu' in basso nel file: al momento della CHIAMATA
         (dopo un add to cart) esiste gia', ma il fallback evita sorprese se
         qualcuno sposta il blocco. Non usiamo il fetch patchato per non far
         girare a vuoto gli interceptor del carrello. */
      var f = origFetch || window.fetch;
      f.call(window, '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: {
          _ga_cid: cid,
          _ga_sid: sid,
          _ga_lcn: getLastClickNav() || ''
        } })
      }).catch(function () {});
    } catch (e) {}
  }

  /* Identita' della singola visualizzazione di pagina. Rigenerata al load E al
     ritorno da bfcache, cosi' l'impression della griglia e' una-per-pagina. */
  function nuovoPageviewId() {
    return Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
  }
  var pageviewId = nuovoPageviewId();

  function getTemplate() {
    var m = (document.body.className || '').match(/template-([a-z0-9_-]+)/);
    return m ? m[1] : 'unknown';
  }

  function collectionHandle() {
    var m = location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function safeText(el) {
    return el ? (el.textContent || '').trim().slice(0, 100) : '';
  }

  function debounce(fn, wait) {
    var t = 0;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ============================================================
     0.5 LIST CONTEXT (sessionStorage) per propagazione list → add_to_cart
     ============================================================ */

  var LIST_CTX_KEY = '__ga4_list_ctx';
  var LIST_CTX_TTL_MS = 3 * 60 * 1000;

  function rememberListContext(productId, listId, listName) {
    if (!productId || !listId) return;
    try {
      sessionStorage.setItem(LIST_CTX_KEY, JSON.stringify({
        product_id: String(productId),
        list_id: listId,
        list_name: listName || listId,
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function getListContextForProduct(productId) {
    if (!productId) return null;
    try {
      var raw = sessionStorage.getItem(LIST_CTX_KEY);
      if (!raw) return null;
      var ctx = JSON.parse(raw);
      if (!ctx || Date.now() - ctx.ts > LIST_CTX_TTL_MS) return null;
      if (String(ctx.product_id) !== String(productId)) return null;
      return ctx;
    } catch (e) { return null; }
  }

  /* ============================================================
     0.6 CART SNAPSHOT (serializzato — vedi mutation chain)
     ============================================================ */

  var cartSnapshot = {
    items: {},
    total_price: 0,
    /* Subtotale prodotti PRE sconto d'ordine: e' il numero su cui Shopify
       valuta il BXGY del regalo e su cui la barra del drawer misura il
       progresso. total_price (post sconto) e' un'altra cosa e con un coupon
       attivo diverge. Usato SOLO per gli eventi di soglia regalo. */
    qualifying_subtotal: 0,
    item_count: 0,
    total_discount: 0,
    has_gift: false,
    discount_codes: []
  };

  /* ------------------------------------------------------------
     item_name = titolo prodotto NUDO. Il formato (100 ml, 50 g...)
     viaggia in item_variant, mai appeso al nome.
     Shopify espone due campi sulla riga di carrello:
       • product_title → "Crema baby idratante e lenitiva"
       • title         → "Crema baby idratante e lenitiva - 100 ml"
     Se product_title manca (righe di app esterne, bundle, regali) il
     fallback su title reintrodurrebbe il suffisso, e su una riga gia'
     sporca lo raddoppierebbe ("... - 100 ml - 100 ml"): qui la coda
     viene tolta, anche ripetuta.
     ------------------------------------------------------------ */
  function nomeProdottoNudo(it) {
    if (!it) return '';
    if (it.product_title) return it.product_title;
    var nome = it.title || '';
    var coda = it.variant_title ? ' - ' + it.variant_title : '';
    if (!coda) return nome;
    while (nome.length > coda.length && nome.slice(-coda.length) === coda) {
      nome = nome.slice(0, -coda.length);
    }
    return nome;
  }

  function snapshotFromCart(cart) {
    var items = {};
    var hasGift = false;
    (cart.items || []).forEach(function (it) {
      /* 2026-10-11: chiave STABILE. it.key cambia a ogni cambio di quantita'
         (Shopify rigenera l'hash della riga), quindi diffCart leggeva ogni
         +1/-1 come «riga tolta»: cart_drawer_item_remove falso e niente
         increase/decrease. Si confronta per variante, con il regalo (riga
         azzerata) tenuto a parte; due righe della stessa variante si sommano. */
      var isGiftLine = it.final_line_price === 0 || it.total_discount === it.original_line_price;
      if (isGiftLine) hasGift = true;
      var stableKey = String(it.variant_id) + (isGiftLine ? ':regalo' : '');
      var prev = items[stableKey];
      if (prev) {
        prev.quantity += it.quantity;
        prev.line_value += it.final_line_price / 100;
        return;
      }
      items[stableKey] = {
        quantity: it.quantity,
        line_value: it.final_line_price / 100,
        product_title: nomeProdottoNudo(it),
        variant_id: it.variant_id,
        product_id: it.product_id,
        variant_title: it.variant_title,
        product_type: it.product_type || '',
        price: (it.price || 0) / 100
      };
    });
    var codes = [];
    if (cart.cart_level_discount_applications) {
      /* 2026-10-11: /cart.js scrive il codice in a.title, mentre
         /cart/change.js e /cart/update.js lo annidano in
         a.discount_application.title. Leggendo solo il primo, ogni cambio
         nel carrello faceva "sparire" il codice: cart_drawer_discount_removed
         falso (~6 per sessione), has_discount e coupon persi. */
      cart.cart_level_discount_applications.forEach(function (a) {
        var t = a && (a.title || (a.discount_application && a.discount_application.title));
        if (t) codes.push(t);
      });
    }
    return {
      items: items,
      total_price: (cart.total_price || 0) / 100,
      qualifying_subtotal: (cart.items_subtotal_price || 0) / 100,
      item_count: cart.item_count || 0,
      total_discount: (cart.total_discount || 0) / 100,
      has_gift: hasGift,
      discount_codes: codes
    };
  }

  function diffCart(before, after) {
    var changes = [];
    Object.keys(after.items).forEach(function (key) {
      var b = before.items[key];
      var a = after.items[key];
      if (!b) changes.push({ type: 'add', key: key, item: a, qty_before: 0, qty_after: a.quantity });
      else if (b.quantity !== a.quantity) {
        changes.push({ type: a.quantity > b.quantity ? 'increase' : 'decrease', key: key, item: a, qty_before: b.quantity, qty_after: a.quantity });
      }
    });
    Object.keys(before.items).forEach(function (key) {
      if (!after.items[key]) {
        changes.push({ type: 'remove', key: key, item: before.items[key], qty_before: before.items[key].quantity, qty_after: 0 });
      }
    });
    return changes;
  }

  function itemFromCartLine(it, idx) {
    return {
      item_id: String(it.variant_id),
      item_name: it.product_title,
      item_variant: it.variant_title,
      item_brand: 'Laqqua',
      item_category: it.product_type || '',
      price: it.price,
      quantity: it.quantity,
      product_id: String(it.product_id),
      index: idx
    };
  }

  function itemsArrayFromCart(snap) {
    return Object.keys(snap.items).map(function (k, idx) {
      return itemFromCartLine(snap.items[k], idx);
    });
  }

  /* ============================================================
     1. ADD TO CART — pending source queue (FIFO con TTL)
     ============================================================ */

  /* Queue invece di variabile globale singola: gestisce add concorrenti */
  var pendingAddQueue = [];
  var PENDING_TTL_MS = 8000;

  function pushPendingSource(entry) {
    var now = Date.now();
    // Pulisci entry vecchie
    pendingAddQueue = pendingAddQueue.filter(function (e) { return now - e.ts < PENDING_TTL_MS; });
    pendingAddQueue.push(entry);
  }

  function consumePendingSource() {
    var now = Date.now();
    while (pendingAddQueue.length > 0) {
      var first = pendingAddQueue.shift();
      if (now - first.ts < PENDING_TTL_MS) return first;
    }
    return null;
  }

  function deduceAddToCartSource(btn) {
    if (!btn) return 'unknown';

    if (btn.closest('cart-drawer, [data-cart-drawer], .cart-drawer')) {
      if (btn.closest('[data-gift-block], .cart-gift-unlock')) return 'cart_drawer_gift';
      if (btn.closest('[data-bundle-widget], [data-bundle-products]')) return 'cart_drawer_bundle_upsell';
      return 'cart_drawer_upsell';
    }
    if (btn.closest('cart-bar, [data-cart-bar]')) return 'pdp_sticky_bar';

    var section = btn.closest('[data-section-type]');
    var sectionType = section ? section.getAttribute('data-section-type') : '';

    if (sectionType === 'featured-product') return 'featured_product_section';
    /* Sul sito la sezione dei correlati si chiama `related`, non
       `related-products`: il ramo non scattava mai e quei clic finivano in
       'collection_quick_add' o in 'unknown'. Verificato sul DOM live. */
    if (sectionType === 'related' || sectionType === 'related-products' || sectionType === 'recommendations') return 'related_products';
    if (sectionType === 'complementary-products') return 'complementary_products';
    if (sectionType === 'recently-viewed') return 'recently_viewed';
    if (sectionType === 'bundle-routine' || btn.closest('[data-bundle-routine]')) return 'bundle_routine';
    /* Le sezioni della home non hanno `data-section-type`: si riconoscono
       dalla classe. `index-products` e' un carosello di prodotti in home. */
    var homeSec = btn.closest('.index-products, .index-collections-list, .index-hero');
    if (homeSec) return 'home_carousel';

    /* I due blocchi di card della scheda prodotto stanno dentro
       quick-add-product: senza questi rami finivano in 'collection_quick_add'. */
    if (btn.closest('.product__block.upsell-products')) return 'pdp_routine';
    if (btn.closest('.product__block.bundle-products')) return 'pdp_bundle';

    if (btn.matches('[data-quick-add-btn]') || btn.closest('quick-add-product')) {
      if (btn.closest('product-quick-add, [data-quick-add-modal]')) return 'collection_quick_add_modal';
      if (btn.closest('[data-product-siblings]')) return 'product_siblings';
      return 'collection_quick_add';
    }

    if (btn.closest('product-form, [data-product-form]') || (getTemplate() === 'product' && btn.closest('main, .product'))) {
      return 'pdp';
    }

    return 'unknown';
  }

  function getSectionId(btn) {
    var s = btn && btn.closest('[data-section-id]');
    return s ? s.getAttribute('data-section-id') : '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '.quick-add__button, .product-form__submit, button[name="add"], ' +
      '.btn--add-to-cart, .product-item__submit, .product__submit__add, ' +
      '.product__submit button[type="submit"], form[action*="/cart/add"] button[type="submit"], ' +
      '[data-gift-button], [data-quick-add-btn]'
    );
    if (!btn || btn.disabled || btn.classList.contains('is-disabled')) return;

    var form = btn.closest('form[action*="/cart/add"]');
    var variantInput = form && form.querySelector('input[name="id"], select[name="id"]');
    var attemptedVariantId = variantInput ? variantInput.value : (btn.getAttribute('data-variant-id') || '');

    pushPendingSource({
      source: deduceAddToCartSource(btn),
      section_id: getSectionId(btn),
      template: getTemplate(),
      is_gift_action: btn.getAttribute('data-gift-action') === 'remove' ? 'remove' : 'add',
      attempted_variant_id: attemptedVariantId,
      ts: Date.now()
    });
  }, true);

  /* ============================================================
     2. FETCH WRAP: add_to_cart + cart mutations
        Mutation chain per evitare race condition tra fetch concorrenti
     ============================================================ */

  var pendingDiscountCode = null;
  var cartMutationChain = Promise.resolve();

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');
    var isAdd = urlStr.indexOf('/cart/add') !== -1;
    var isChange = urlStr.indexOf('/cart/change') !== -1;
    var isUpdate = urlStr.indexOf('/cart/update') !== -1;
    var isCartJs = /\/cart\.js(?:[?#]|$)/.test(urlStr);

    var result = origFetch.apply(this, arguments);

    if (isAdd) {
      result.then(function (resp) {
        return resp.clone().json();
      }).then(function (added) {
        var src = consumePendingSource() || {};
        if (!added || added.status) {
          send('add_to_cart_error', {
            error_code: (added && added.status) ? String(added.status) : 'unknown',
            error_message: (added && (added.message || added.description)) ? String(added.message || added.description).slice(0, 200) : '',
            attempted_variant_id: src.attempted_variant_id || '',
            add_to_cart_source: src.source || 'unknown',
            add_to_cart_template: src.template || getTemplate()
          });
          return;
        }
        var addedItems = added.items ? added.items : [added];
        var totalValue = 0;
        var firstProductId = String((addedItems[0] && addedItems[0].product_id) || '');
        var listCtx = getListContextForProduct(firstProductId);
        var items = addedItems.map(function (it, idx) {
          var val = (it.final_line_price || it.line_price || (it.price * it.quantity) || 0) / 100;
          totalValue += val;
          var item = {
            item_id: String(it.variant_id || ''),
            item_name: nomeProdottoNudo(it),
            item_variant: it.variant_title || '',
            item_brand: 'Laqqua',
            item_category: it.product_type || '',
            price: (it.price || 0) / 100,
            quantity: it.quantity || 1,
            product_id: String(it.product_id || ''),
            index: idx
          };
          if (listCtx) {
            item.item_list_id = listCtx.list_id;
            item.item_list_name = listCtx.list_name;
          }
          return item;
        });
        var atcPayload = {
          currency: 'EUR',
          value: totalValue,
          items: items,
          add_to_cart_source: src.source || 'unknown',
          add_to_cart_template: src.template || getTemplate(),
          add_to_cart_section_id: src.section_id || ''
        };
        if (listCtx) {
          atcPayload.item_list_id = listCtx.list_id;
          atcPayload.item_list_name = listCtx.list_name;
        }
        send('add_to_cart_enriched', atcPayload);
        marcaCarrelloConIdGa4();
        /* Il cassetto si apre da solo subito dopo: se nessun clic ha gia'
           scritto un motivo, questo e' il motivo. Prima restava 'unknown'
           in 90 casi su 93. */
        if (!window.__lastCartOpenTrigger) window.__lastCartOpenTrigger = 'auto_after_add';
      }).catch(function () {
        // Errore di rete o JSON malformato: consuma comunque la queue
        var src = consumePendingSource() || {};
        send('add_to_cart_error', {
          error_code: 'network_or_parse',
          error_message: '',
          attempted_variant_id: src.attempted_variant_id || '',
          add_to_cart_source: src.source || 'unknown'
        });
      });
    }

    if (isChange || isUpdate) {
      /* Serializzazione: cattura beforeSnap solo quando la catena precedente
         e' risolta, cosi' cartSnapshot riflette gia' le mutation precedenti. */
      cartMutationChain = cartMutationChain.then(function () {
        return result.then(function (resp) {
          return resp.clone().json();
        }).then(function (cart) {
          if (!cart || !cart.items) return;
          var beforeSnapshot = JSON.parse(JSON.stringify(cartSnapshot));
          var afterSnapshot = snapshotFromCart(cart);
          var changes = diffCart(beforeSnapshot, afterSnapshot);

          changes.forEach(function (ch) {
            if (ch.type === 'increase') {
              send('cart_drawer_quantity_increase', {
                item_id: String(ch.item.variant_id),
                product_id: String(ch.item.product_id),
                item_name: ch.item.product_title,
                item_category: ch.item.product_type || '',
                quantity_before: ch.qty_before,
                quantity_after: ch.qty_after,
                line_value: ch.item.line_value
              });
            } else if (ch.type === 'decrease') {
              send('cart_drawer_quantity_decrease', {
                item_id: String(ch.item.variant_id),
                product_id: String(ch.item.product_id),
                item_name: ch.item.product_title,
                item_category: ch.item.product_type || '',
                quantity_before: ch.qty_before,
                quantity_after: ch.qty_after,
                line_value: ch.item.line_value
              });
            } else if (ch.type === 'remove') {
              /* remove_from_cart standard e' gestito dalla Google channel.
                 Manteniamo solo il breadcrumb custom con remove_method. */
              send('cart_drawer_item_remove', {
                item_id: String(ch.item.variant_id),
                product_id: String(ch.item.product_id),
                item_name: ch.item.product_title,
                item_category: ch.item.product_type || '',
                quantity_before: ch.qty_before,
                line_value: ch.item.line_value,
                remove_method: ch.qty_after === 0 ? 'qty_zero' : 'x_button'
              });
            }
          });

          /* Discount detection */
          var codesAdded = afterSnapshot.discount_codes.filter(function (c) {
            return beforeSnapshot.discount_codes.indexOf(c) === -1;
          });
          var codesRemoved = beforeSnapshot.discount_codes.filter(function (c) {
            return afterSnapshot.discount_codes.indexOf(c) === -1;
          });
          if (codesAdded.length > 0) {
            send('cart_drawer_discount_apply_success', {
              discount_code: codesAdded[0] || pendingDiscountCode || '',
              discount_amount: Math.max(0, afterSnapshot.total_discount - beforeSnapshot.total_discount),
              cart_value_before: beforeSnapshot.total_price,
              cart_value_after: afterSnapshot.total_price
            });
            pendingDiscountCode = null;
          } else if (pendingDiscountCode && changes.length === 0 &&
                     afterSnapshot.total_discount === beforeSnapshot.total_discount) {
            /* Submit avvenuto ma codice non applicato e cart invariato → errore Shopify */
            send('cart_drawer_discount_apply_error', {
              discount_code: pendingDiscountCode,
              cart_total: afterSnapshot.total_price,
              error_reason: 'code_rejected_or_invalid'
            });
            pendingDiscountCode = null;
          }
          if (codesRemoved.length > 0) {
            send('cart_drawer_discount_removed', {
              discount_code: codesRemoved[0],
              cart_total: afterSnapshot.total_price
            });
          }

          /* Gift threshold detection.
             2026-08-27: due correzioni. (1) La soglia arriva dall'attributo
             del blocco, che ora il tema emette davvero: prima cadeva sempre
             sul fallback '69' e restava 69 anche cambiando la soglia.
             (2) Il confronto usa il subtotale prodotti, non il totale pagato:
             con un coupon attivo il totale scende sotto soglia mentre il
             regalo resta sbloccato, quindi l'unlock non veniva registrato e
             il relock scattava per finta. `cart_total` resta il totale
             pagato, per continuita' con lo storico. */
          var giftBlock = document.querySelector('[data-gift-block]');
          var threshold = giftThreshold();
          if (giftBlock && threshold != null) {
            var qBefore = beforeSnapshot.qualifying_subtotal;
            var qAfter = afterSnapshot.qualifying_subtotal;
            if (qBefore < threshold && qAfter >= threshold) {
              send('cart_drawer_gift_unlock_threshold', {
                cart_total: afterSnapshot.total_price,
                qualifying_subtotal: qAfter,
                gift_threshold: threshold,
                delta_to_threshold: qAfter - threshold
              });
            } else if (qBefore >= threshold && qAfter < threshold) {
              send('cart_drawer_gift_relock_threshold', {
                cart_total: afterSnapshot.total_price,
                qualifying_subtotal: qAfter,
                gift_threshold: threshold,
                delta_to_threshold: threshold - qAfter
              });
            }
          }

          cartSnapshot = afterSnapshot;
        }).catch(function () {});
      });
    }

    if (isCartJs) {
      cartMutationChain = cartMutationChain.then(function () {
        return result.then(function (resp) {
          return resp.clone().json();
        }).then(function (cart) {
          if (cart && cart.items) cartSnapshot = snapshotFromCart(cart);
        }).catch(function () {});
      });
    }

    return result;
  };

  /* ============================================================
     3. CART DRAWER + view_cart
     ============================================================ */

  var drawerOpenAt = 0;
  var drawerScrollMax = 0;
  var drawerCloseMethod = 'unknown';
  var bootstrapPhase = true;

  function instrumentDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__ga4Instrumented) return;
    drawer.__ga4Instrumented = true;

    function check() {
      var isOpen = drawer.classList.contains('is-open') ||
                   drawer.hasAttribute('open') ||
                   drawer.getAttribute('aria-hidden') === 'false';

      /* Durante bootstrap, se drawer e' gia' aperto, non fire open: stato preservato. */
      if (isOpen && !drawerOpenAt && bootstrapPhase) {
        drawerOpenAt = Date.now();
        return;
      }

      if (isOpen && !drawerOpenAt) {
        drawerOpenAt = Date.now();
        drawerScrollMax = 0;
        drawerCloseMethod = 'unknown';
        send('cart_drawer_open', {
          value: cartSnapshot.total_price,
          cart_item_count: cartSnapshot.item_count,
          drawer_trigger: window.__lastCartOpenTrigger || 'unknown',
          has_gift: cartSnapshot.has_gift,
          has_discount: cartSnapshot.discount_codes.length > 0
        });
        /* Nota: view_cart standard NON e' firato qui — gestito dalla Google channel. */
        window.__lastCartOpenTrigger = null;
        attachDrawerScroll();
      } else if (!isOpen && drawerOpenAt) {
        send('cart_drawer_close', {
          dwell_seconds: Math.round((Date.now() - drawerOpenAt) / 1000),
          value: cartSnapshot.total_price,
          cart_item_count: cartSnapshot.item_count,
          max_scroll_percent: drawerScrollMax,
          close_method: drawerCloseMethod
        });
        drawerOpenAt = 0;
        drawerCloseMethod = 'unknown';
      }
    }

    new MutationObserver(check).observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden']
    });
    check();
  }

  function attachDrawerScroll() {
    var body = document.querySelector('[data-cart-drawer-body]');
    if (!body || body.__ga4ScrollAttached) return;
    body.__ga4ScrollAttached = true;
    var fired = {};
    var thresholds = [25, 50, 75, 100];
    body.addEventListener('scroll', function () {
      var scrollable = body.scrollHeight - body.clientHeight;
      if (scrollable <= 0) return;
      var pct = Math.round((body.scrollTop / scrollable) * 100);
      if (pct > drawerScrollMax) drawerScrollMax = pct;
      thresholds.forEach(function (t) {
        if (pct >= t && !fired[t]) {
          fired[t] = true;
          send('cart_drawer_scroll_depth', {
            percent: t,
            cart_item_count: cartSnapshot.item_count
          });
        }
      });
    }, { passive: true });
  }

  /* Cosa apre il drawer */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle], a[href="/cart"], .navlink--cart, .header__cart, [data-cart-icon]')) {
      window.__lastCartOpenTrigger = 'icon_click';
    } else if (e.target.closest('.cart-toast, [data-cart-toast], [data-toast-cart-link]')) {
      window.__lastCartOpenTrigger = 'toast_click';
    } else if (e.target.closest('cart-bar, [data-cart-bar]')) {
      window.__lastCartOpenTrigger = 'sticky_bar';
    }
  });

  /* Cosa chiude il drawer: traccia il metodo (poi propagato in cart_drawer_close) */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) {
      drawerCloseMethod = 'close_button';
    } else if (e.target.closest('[data-drawer-underlay], .drawer__underlay, [data-cart-drawer-underlay]')) {
      drawerCloseMethod = 'overlay';
    } else if (e.target.closest('[name="checkout"], [data-cart-checkout]')) {
      drawerCloseMethod = 'checkout';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawerOpenAt) drawerCloseMethod = 'escape';
  });

  /* Empty state link click ("continua lo shopping") */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-empty] a');
    if (!a) return;
    send('cart_drawer_empty_link_clicked', {
      link_text: safeText(a),
      link_url: a.getAttribute('href') || ''
    });
  });

  /* Discount block */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-discount-toggle]')) {
      send('cart_drawer_discount_toggle_open', {
        cart_total: cartSnapshot.total_price,
        cart_item_count: cartSnapshot.item_count
      });
    } else if (e.target.closest('[data-discount-close]')) {
      send('cart_drawer_discount_toggle_close', {});
    } else if (e.target.closest('[data-info-tip]')) {
      send('cart_drawer_discount_info_tip_clicked', {});
    } else if (e.target.closest('[data-apply-discount]')) {
      var form = e.target.closest('[data-discount-form], form');
      var input = form && form.querySelector('[data-discount-input]');
      if (input && input.value.trim()) {
        pendingDiscountCode = input.value.trim();
        send('cart_drawer_discount_apply_attempt', {
          discount_code: pendingDiscountCode,
          cart_total: cartSnapshot.total_price
        });
      }
    }
  });

  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches('[data-discount-input]') && !e.target.__ga4Focused) {
      e.target.__ga4Focused = true;
      send('cart_drawer_discount_input_focus', { cart_total: cartSnapshot.total_price });
    }
  });

  /* Gift block: re-armato su state change */
  var lastGiftState = null;
  function watchGiftBlock() {
    var gift = document.querySelector('[data-gift-block]');
    if (!gift) return;
    var currentState = gift.classList.contains('is-added') ? 'ADDED'
                     : gift.classList.contains('is-ready') ? 'UNLOCKED'
                     : 'LOCKED';
    if (currentState === lastGiftState) return;
    /* Visibility check */
    var rect = gift.getBoundingClientRect();
    var visible = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
    if (!visible) {
      /* Non visibile: attendi visibility prima di firare */
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          fireGiftView(gift, currentState);
          lastGiftState = currentState;
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.6 }).observe(gift);
      return;
    }
    fireGiftView(gift, currentState);
    lastGiftState = currentState;
  }

  function fireGiftView(gift, state) {
    send('cart_drawer_gift_block_view', {
      gift_state: state,
      cart_total: cartSnapshot.total_price,
      gift_threshold: giftThreshold(),
      gift_product: gift.getAttribute('data-gift-name') || ''
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gift-button]');
    if (!btn) return;
    var action = btn.getAttribute('data-gift-action') === 'remove' ? 'remove' : 'add';
    send('cart_drawer_gift_button_clicked', {
      action: action,
      gift_variant_id: btn.getAttribute('data-gift-variant-id') || '',
      cart_total: cartSnapshot.total_price,
      /* Stato letto dalla CARD, non dalle classi del bottone: l'handler del
         regalo azzera is-ready/is-paid sul bottone al click e (a seconda
         dell'ordine di registrazione dei listener) qui arrivava sempre
         'LOCKED' anche su click legittimamente sbloccati. Le classi della card
         non vengono toccate al click. Nota: 'is-paid' era mappato su 'ADDED' —
         ora e' 'PAID', che e' cio' che significa davvero. */
      gift_state_before: giftCardState(),
      /* Da DOVE e' partito l'add: la card nel flusso o il promemoria sticky
         che compare quando la card esce dalla vista. E' il parametro che
         risponde alla domanda "il promemoria recupera davvero qualcuno?" —
         senza, i due click sono indistinguibili. */
      gift_surface: btn.hasAttribute('data-gift-mini-btn') ? 'sticky_reminder' : 'card'
    });
  });

  /* ── PROMEMORIA STICKY REGALO ──
     La riga compatta entra in scena con la classe is-on sull'ancora. Impression
     UNA sola volta per pageview: la riga va e viene a ogni passaggio di scroll,
     contarla ogni volta gonfierebbe il denominatore e renderebbe il tasso di
     conversione per impression privo di significato. */
  var reminderSeen = false;
  var reminderNode = null;
  var reminderObserver = null;

  function watchGiftReminder() {
    var anchor = document.querySelector('[data-gift-mini-anchor]');
    if (!anchor || anchor === reminderNode) return;
    /* Il drawer si ri-renderizza: se il nodo cambia, ri-arma l'observer. */
    if (reminderObserver) reminderObserver.disconnect();
    reminderNode = anchor;

    function check() {
      if (reminderSeen || !anchor.classList.contains('is-on')) return;
      reminderSeen = true;
      send('cart_drawer_gift_reminder_view', {
        cart_total: cartSnapshot.total_price,
        gift_threshold: giftThreshold()
      });
    }

    reminderObserver = new MutationObserver(check);
    reminderObserver.observe(anchor, { attributes: true, attributeFilter: ['class'] });
    check();
  }

  /* Soglia regalo letta dal blocco. Ritorna null se il blocco non c'e' o non
     espone l'attributo: fino al 2026-08-27 qui c'era un fallback '69' e, dato
     che il tema l'attributo non lo emetteva affatto, OGNI evento riportava 69
     anche dopo un cambio di soglia. Un parametro assente si vede nei report,
     un numero sbagliato no. */
  function giftThreshold() {
    var gift = document.querySelector('[data-gift-block]');
    var raw = gift && gift.getAttribute('data-gift-threshold');
    if (!raw) return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  function giftCardState() {
    var card = document.querySelector('[data-gift-block]');
    if (!card) return 'UNKNOWN';
    if (card.classList.contains('is-added')) return 'ADDED';
    if (card.classList.contains('is-paid')) return 'PAID';
    if (card.classList.contains('is-unlocked')) return 'UNLOCKED';
    return 'LOCKED';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-gift-mini-close]')) return;
    send('cart_drawer_gift_reminder_dismiss', {
      cart_total: cartSnapshot.total_price,
      gift_threshold: giftThreshold()
    });
  });

  /* Collapsible blocks (gift-note, order-note, shipping-calculator, upsell) */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-collapsible-trigger]');
    if (!trigger) return;
    var details = trigger.closest('details, [data-collapsible]');
    if (!details) return;
    var isOpen = details.hasAttribute('open') || details.classList.contains('is-open');
    var willOpen = !isOpen;
    /* Solo la prima riga di testo vero del titolo. «Quali ingredienti?» ha
       dentro un <style> e il badge Yuka: col textContent intero finivano nel
       parametro pezzi di CSS, e la stessa voce si spezzava in due valori. */
    var clone = trigger.cloneNode(true);
    clone.querySelectorAll('style, script, noscript, svg, template').forEach(function (n) { n.remove(); });
    var label = ((clone.textContent || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean)[0] || '').slice(0, 60);

    /* Il soffietto e' DENTRO il cassetto carrello? Prima questo controllo non
       c'era e i soffietti di FAQ e footer finivano negli eventi del carrello. */
    var inCart = !!details.closest('cart-drawer, [data-cart-drawer], .cart-drawer, [data-section-id*="cart-drawer"]');

    if (inCart) {
      var blockType = 'unknown';
      if (details.hasAttribute('data-upsell-widget') || details.hasAttribute('data-bundle-widget') || details.classList.contains('cart__widget--products')) blockType = 'upsell_widget';
      else if (details.querySelector('[name="note"]')) blockType = 'order_note';
      else if (details.classList.contains('cart__widget--gift-note') || details.querySelector('[name*="gift"]')) blockType = 'gift_note';
      else if (details.querySelector('[name^="address"]')) blockType = 'shipping_calculator';
      else if (details.querySelector('[data-discount-toggle], [name*="discount"]')) blockType = 'discount_block';
      send(willOpen ? 'cart_drawer_block_open' : 'cart_drawer_block_close', {
        block_type: blockType,
        menu_item_text: label,
        cart_total: cartSnapshot.total_price
      });
      return;
    }

    /* Fuori dal carrello: footer, FAQ, blocchi della scheda prodotto. Prima
       questi clic erano invisibili (o peggio, contati come carrello). I
       parametri usano nomi GIA' registrati come dimensione in GA4
       (block_type, menu_item_text, page_type, section_id) per non dipendere
       da una registrazione nuova. */
    var sec = details.closest('[data-section-id]');
    var secId = sec ? (sec.getAttribute('data-section-id') || '') : '';
    var zona = 'altro';
    if (details.closest('footer, .site-footer-wrapper')) zona = 'footer';
    else if (details.closest('.faq, [data-section-id*="accordion_group"]')) zona = 'faq';
    else if (details.closest('[data-product-id], .product-block')) zona = 'scheda_prodotto';
    send(willOpen ? 'page_block_opened' : 'page_block_closed', {
      block_type: zona,
      menu_item_text: label,
      page_type: getTemplate(),
      section_id: secId
    });
  /* true = fase di cattura. Il tema apre il soffietto nel suo gestore sul
     bottone, che gira PRIMA di un ascoltatore sul document in fase di bubbling:
     qui arrivava con "open" gia' messo e ogni apertura veniva contata come
     chiusura (dal 30 lug al 19 set 2026: 1.789 page_block_closed e nessun
     page_block_opened; stessa cosa nel cassetto carrello). In cattura si legge
     lo stato di prima del click, che e' quello che serve. */
  }, true);

  /* Righe «Altri ingredienti chiave» in scheda prodotto (product-inci-enhance,
     dall'8 ott 2026): sono <details> nativi, senza data-collapsible-trigger,
     quindi l'ascoltatore sopra non le vede. 'toggle' non risale: va preso in
     cattura. Stesso evento dei soffietti, ma con il prefisso «Ingrediente: »
     nel testo: la dashboard (Comportamento › Quali blocchi aprono) legge
     menu_item_text senza poterlo incrociare con block_type, e senza prefisso
     «Olio di Jojoba» finirebbe confuso fra spedizioni, resi e FAQ. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.classList || !d.classList.contains('lq-ing__row') || !d.open) return;
    var n = d.querySelector('.lq-ing__name');
    send('page_block_opened', {
      block_type: 'ingrediente',
      menu_item_text: ('Ingrediente: ' + (n ? n.textContent.trim() : '')).slice(0, 60),
      page_type: getTemplate()
    });
  }, true);

  document.addEventListener('blur', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('textarea[name="note"], input[name="note"]')) {
      if (t.value && t.value.trim()) send('cart_drawer_order_note_filled', { note_length: t.value.length });
    } else if (t.matches('textarea[name*="gift"], input[name*="gift_note"], [data-gift-note-input]')) {
      if (t.value && t.value.trim()) send('cart_drawer_gift_note_filled', { note_length: t.value.length });
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-shipping-calculator-button], button[name="calculate"]');
    if (!btn) return;
    var form = btn.closest('form, [data-collapsible]');
    var country = form && form.querySelector('[name="address[country]"]');
    var zip = form && form.querySelector('[name="address[zip]"]');
    send('cart_drawer_shipping_calculator_submit', {
      country: country ? country.value : '',
      zip: zip ? zip.value : '',
      cart_total: cartSnapshot.total_price
    });
  });

  /* Upsell impression + click */
  function watchCartUpsells() {
    var upsells = document.querySelectorAll('[data-upsell-products] [data-product-id], [data-bundle-products] [data-product-id], [data-product-upsell-ajax] [data-product-id]');
    upsells.forEach(function (card) {
      if (card.__ga4UpsellWatched) return;
      card.__ga4UpsellWatched = true;
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          send('cart_drawer_upsell_view', {
            product_id: card.getAttribute('data-product-id') || '',
            product_title: card.getAttribute('data-product-title') || safeText(card.querySelector('h3, h4, .product-item__title, [data-product-title]')),
            upsell_block: card.closest('[data-bundle-products]') ? 'bundle' : 'upsell'
          });
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.5 }).observe(card);
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-upsell-products] a[href*="/products/"], [data-bundle-products] a[href*="/products/"], [data-product-upsell-ajax] a[href*="/products/"]');
    if (!link) return;
    if (link.closest('button')) return;
    var card = link.closest('[data-product-id]');
    var productId = card ? (card.getAttribute('data-product-id') || '') : '';
    rememberListContext(productId, 'cart_drawer_upsell', 'Cart drawer upsell');
    send('cart_drawer_upsell_product_clicked', {
      product_id: productId,
      product_title: card ? (card.getAttribute('data-product-title') || safeText(link)) : safeText(link),
      target_url: link.getAttribute('href') || ''
    });
  });

  /* Click line item: vai al prodotto */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-item] a[href*="/products/"]');
    if (!link) return;
    if (e.target.closest('[data-item-remove]')) return;
    var item = link.closest('[data-item]');
    send('cart_drawer_line_item_clicked', {
      item_key: item ? item.getAttribute('data-item') : '',
      item_title: item ? item.getAttribute('data-item-title') : safeText(link),
      target_url: link.getAttribute('href') || ''
    });
  });

  /* Terms toggle */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-acceptance-checkbox]')) return;
    send('cart_drawer_terms_toggle', { accepted: !!e.target.checked });
  });

  /* begin_checkout (GA4 standard) con guard double-click */
  var checkoutFiring = false;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[name="checkout"], [data-cart-checkout]');
    if (!b) return;
    if (checkoutFiring) return;
    checkoutFiring = true;
    setTimeout(function () { checkoutFiring = false; }, 1500);
    var checkoutSource = b.closest('cart-drawer, [data-cart-drawer]') ? 'cart_drawer' : 'cart_page';
    send('begin_checkout_enriched', {
      currency: 'EUR',
      value: cartSnapshot.total_price,
      items: itemsArrayFromCart(cartSnapshot),
      coupon: cartSnapshot.discount_codes[0] || undefined,
      checkout_source: checkoutSource,
      has_gift: cartSnapshot.has_gift,
      cart_item_count: cartSnapshot.item_count
    });
  });

  /* ============================================================
     4. VIEW_ITEM (PDP)
     ============================================================ */

  function fireViewItem() {
    if (getTemplate() !== 'product') return;
    var ctx = window.__laqquaProductCtx;
    if (!ctx || !ctx.id) return;
    if (window.__ga4ViewItemFired) return;
    window.__ga4ViewItemFired = true;
    /* Propagazione list context: se l'utente e' arrivato qui da una lista,
       il payload include item_list_id / item_list_name. */
    var listCtx = getListContextForProduct(ctx.id);
    var hasVideo = !!document.querySelector('product-media video, [data-product-media] video');
    var payload = {
      currency: 'EUR',
      value: ctx.price || 0,
      items: [{
        item_id: String(ctx.variant_id || ctx.id),
        item_name: ctx.title || '',
        item_variant: '',
        item_brand: ctx.vendor || 'Laqqua',
        item_category: ctx.type || '',
        price: ctx.price || 0,
        compare_at_price: ctx.compare_at_price || 0,
        product_id: String(ctx.id),
        index: 0
      }],
      product_handle: ctx.handle || '',
      variant_id: ctx.variant_id || '',
      availability: ctx.available ? 'in_stock' : 'out_of_stock',
      image_count: ctx.image_count || 0,
      has_video: hasVideo
    };
    if (listCtx) {
      payload.item_list_id = listCtx.list_id;
      payload.item_list_name = listCtx.list_name;
      payload.items[0].item_list_id = listCtx.list_id;
      payload.items[0].item_list_name = listCtx.list_name;
    }
    send('view_item_enriched', payload);
  }

  /* ============================================================
     5. (rimosso) view_cart standard — gestito da Google channel.
     ============================================================ */

  /* ============================================================
     6. SEARCH
     ============================================================ */

  /* Nomi dei parametri: GA4 rende leggibili solo quelli registrati come
     custom dimension e la property è vicina al limite di 50. Per questo
     ogni dato nuovo viaggia ANCHE su un nome già registrato: la risposta
     su tile_id, la fonte del suggerimento e del risultato su block_type,
     il link su menu_item_url (stessa scelta dei moduli della home).

     9 ottobre 2026: il pannello dell'header ora dice da solo cosa ha trovato
     (assets/laqqua-search.js, eventi lq:search:*). Prima si contavano a
     mano elementi che il tema non usa ([data-product-id], li[role=option]):
     il conteggio era sempre 0 e ogni ricerca risultava «zero risultati»,
     e l'evento partiva 800 ms dopo l'ultimo tasto anche a risposta non
     ancora arrivata. Ora una ricerca si registra quando la risposta è
     arrivata e la persona si è fermata per un secondo, col numero vero. */

  var lastSearchQuery = '';
  var settledTimer = null;

  document.addEventListener('lq:search:results', function (e) {
    var d = e.detail || {};
    clearTimeout(settledTimer);
    settledTimer = setTimeout(function () {
      var q = (d.term || '').trim();
      if (q.length < 2 || q === lastSearchQuery) return;
      lastSearchQuery = q;
      send('search_query_submitted', {
        search_term: q,
        search_results_count: d.count,
        search_products_count: d.products,
        search_answer: d.answer || '',
        tile_id: d.answer || '',
        is_zero_results: d.count === 0,
        search_surface: d.surface || 'header_popdown'
      });
      // Una ricerca con una Risposta non è finita a vuoto, anche senza prodotti
      if (d.count === 0 && !d.answer) {
        send('search_zero_results', { search_term: q, search_surface: d.surface || 'header_popdown' });
      }
    }, 1000);
  });

  // «Lo vorrei» su una cosa che non vendiamo: la classifica dei prodotti richiesti
  document.addEventListener('lq:search:wish', function (e) {
    var d = e.detail || {};
    send('search_wish', { search_term: d.term || '', search_answer: d.answer || '', tile_id: d.answer || '' });
  });

  document.addEventListener('lq:search:answer', function (e) {
    var d = e.detail || {};
    send('search_answer_shown', { search_term: d.term || '', search_answer: d.answer || '', tile_id: d.answer || '', search_surface: d.surface || '' });
  });

  document.addEventListener('lq:search:open', function (e) {
    send('search_drawer_open', { trigger: 'icon_click', search_surface: (e.detail && e.detail.surface) || 'header' });
  });

  /* Chip, ricerche recenti, collezioni, «Vedi tutti», chat: tutto ciò che
     nel pannello non è una riga prodotto. */
  document.addEventListener('lq:search:pick', function (e) {
    var d = e.detail || {};
    if (d.source === 'product' || d.source === 'bestseller_start' || d.source === 'bestseller_zero') return;
    send('search_suggestion_clicked', {
      search_term: d.term || '',
      search_typed: d.typed || '',
      suggestion_source: d.source || 'unknown',
      block_type: d.source || 'unknown',
      link_url: d.href || '',
      menu_item_url: d.href || ''
    });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/search"]');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    send('search_query_submitted', {
      search_term: input.value.trim(),
      search_results_count: -1,
      is_zero_results: false,
      search_surface: 'search_page_submit'
    });
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('header-search-popdown a[href*="/products/"], predictive-search a[href*="/products/"], [data-predictive-search-results] a[href*="/products/"]');
    if (!link) return;
    var item = link.closest('[data-product-id], li');
    var position = item ? parseInt(item.getAttribute('data-lqs-position'), 10) : NaN;
    if (isNaN(position)) {
      var siblings = item && item.parentElement ? Array.from(item.parentElement.children) : [];
      position = siblings.indexOf(item) + 1;
    }
    var productId = item ? (item.getAttribute('data-product-id') || '') : '';
    var listBox = link.closest('[data-lqs-source]');
    var source = listBox ? listBox.getAttribute('data-lqs-source') : 'results';
    var input = link.closest('header-search-popdown') && link.closest('header-search-popdown').querySelector('input[type="search"]');
    var resultSource = source === 'start' ? 'bestseller_start' : source === 'zero' ? 'bestseller_zero' : (source && source.indexOf('answer:') === 0 ? source : 'results');
    rememberListContext(productId, 'search_predictive', 'Predictive search');
    send('search_result_clicked', {
      search_term: (input && input.value.trim()) || lastSearchQuery,
      product_id: productId,
      product_title: safeText(link.querySelector('.product-item__title, h3, h4') || link),
      position: position,
      result_source: resultSource,
      block_type: resultSource,
      search_surface: link.closest('header-search-popdown') ? 'header_popdown' : 'search_page'
    });
  });

  /* ============================================================
     7. COLLECTION FILTERS & SORTING
     ============================================================ */

  function currentFilters() {
    var params = new URLSearchParams(location.search);
    var out = [];
    params.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0) out.push({ name: k, value: v });
    });
    return out;
  }

  function currentSort() {
    return new URLSearchParams(location.search).get('sort_by') || 'manual';
  }

  var prevFilters = currentFilters();
  var prevSort = currentSort();

  function detectFilterChanges() {
    var now = currentFilters();
    var nowKeys = now.map(function (f) { return f.name + '=' + f.value; });
    var prevKeys = prevFilters.map(function (f) { return f.name + '=' + f.value; });
    var added = now.filter(function (f) { return prevKeys.indexOf(f.name + '=' + f.value) === -1; });
    var removed = prevFilters.filter(function (f) { return nowKeys.indexOf(f.name + '=' + f.value) === -1; });
    var handle = collectionHandle();
    var productCountEl = document.querySelector('[data-active-filters-count], .collection-filters__count, [data-product-count]');
    var productCount = productCountEl ? parseInt(productCountEl.textContent.replace(/\D/g, ''), 10) : null;

    added.forEach(function (f) {
      send('collection_filter_apply', {
        filter_name: f.name,
        filter_value: f.value,
        filter_type: f.name.indexOf('price') !== -1 ? 'price_range' : (f.name.indexOf('availability') !== -1 ? 'availability' : 'facet'),
        collection_handle: handle,
        product_count_after: productCount,
        active_filters_count: now.length
      });
    });
    removed.forEach(function (f) {
      send('collection_filter_remove', {
        filter_name: f.name,
        filter_value: f.value,
        collection_handle: handle,
        active_filters_count: now.length
      });
    });

    var nowSort = currentSort();
    if (nowSort !== prevSort) {
      send('collection_sort_change', {
        sort_by: nowSort,
        previous_sort: prevSort,
        collection_handle: handle
      });
      prevSort = nowSort;
    }

    if (added.length === 0 && removed.length === prevFilters.length && prevFilters.length > 1) {
      send('collection_filters_clear_all', {
        collection_handle: handle,
        removed_filters_count: removed.length
      });
    }

    prevFilters = now;
  }

  ['replaceState', 'pushState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () {
      var r = orig.apply(this, arguments);
      setTimeout(detectFilterChanges, 100);
      return r;
    };
  });
  window.addEventListener('popstate', function () { setTimeout(detectFilterChanges, 100); });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-collection-filter-toggle], [data-filter-drawer-open]')) {
      send('collection_filters_drawer_open', {
        collection_handle: collectionHandle(),
        active_filters_count: prevFilters.length
      });
    }
  });

  /* ============================================================
     8. VARIANT SELECTION (PDP) — debounce 300ms
     ============================================================ */

  var debouncedVariantSelected = debounce(function (input) {
    var form = input.closest('product-form, [data-product-form]');
    var fieldset = input.closest('fieldset');
    var label = fieldset && fieldset.querySelector('legend, .form__label');
    var optionName = label ? safeText(label) : (input.name || '');
    var optionValue = input.value || '';
    var variantSelect = form && form.querySelector('select[name="id"], input[name="id"]');
    var variantId = variantSelect ? variantSelect.value : '';
    var priceEl = form && form.querySelector('[data-product-price], .price-item--regular');
    var productEl = input.closest('[data-product-id]');
    send('product_variant_selected', {
      product_id: productEl ? productEl.getAttribute('data-product-id') : '',
      variant_id: variantId,
      option_name: optionName,
      option_value: optionValue,
      price: priceEl ? parseFloat((priceEl.textContent || '').replace(/[^\d,.]/g, '').replace(',', '.')) || null : null,
      availability: form && form.querySelector('[name="add"]:disabled, .is-sold-out') ? 'out_of_stock' : 'in_stock'
    });
  }, 300);

  document.addEventListener('change', function (e) {
    var input = e.target.closest('product-form input[name^="options"], variant-selects input[name^="options"], fieldset.product-form__input input');
    if (!input) return;
    debouncedVariantSelected(input);
  });

  /* ============================================================
     9. NEWSLETTER
     ============================================================ */

  function watchNewsletterForms() {
    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      if (form.__ga4NewsletterWatched) return;
      if (!form.querySelector('input[name="contact[email]"], input[type="email"][name*="email"]')) return;
      var formType = form.getAttribute('id') || '';
      if (formType.indexOf('newsletter') === -1 && !form.closest('[data-newsletter], newsletter-component, footer')) return;
      form.__ga4NewsletterWatched = true;
      var loc = form.closest('footer') ? 'footer'
              : form.closest('[data-popup], popup-component') ? 'popup'
              : getTemplate() === 'newsletter' ? 'page_newsletter'
              : 'unknown';

      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          send('newsletter_form_view', { newsletter_method: loc });
          obs.unobserve(en.target);
        });
      }, { threshold: 0.4 }).observe(form);

      form.addEventListener('submit', function () {
        send('newsletter_form_submitted', {
          newsletter_method: loc,
          has_consent_checkbox: !!form.querySelector('input[type="checkbox"]')
        });
      });
    });
  }

  if (location.search.indexOf('customer_posted=true') !== -1 || location.search.indexOf('accepts_marketing=true') !== -1) {
    send('newsletter_form_success', { newsletter_method: getTemplate() === 'newsletter' ? 'page_newsletter' : 'inferred' });
  }

  /* ============================================================
     10. BUNDLE
     ============================================================ */

  function watchBundle() {
    var bundle = document.querySelector('[data-bundle-routine], [data-bundle-product]');
    if (!bundle || bundle.__ga4Watched) return;
    bundle.__ga4Watched = true;
    var components = bundle.querySelectorAll('[data-bundle-component], [data-bundle-item]');
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        send('bundle_view', {
          bundle_product_id: bundle.getAttribute('data-product-id') || bundle.getAttribute('data-bundle-id') || '',
          bundle_name: bundle.getAttribute('data-bundle-name') || safeText(bundle.querySelector('h1, h2, .product__title')),
          component_count: components.length,
          bundle_savings_pct: parseFloat(bundle.getAttribute('data-bundle-savings-pct')) || null,
          bundle_savings_amount: parseFloat(bundle.getAttribute('data-bundle-savings-amount')) || null
        });
        obs.unobserve(en.target);
      });
    }, { threshold: 0.4 }).observe(bundle);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-add-all], [data-bundle-routine] [name="add"], [data-bundle-product] button[type="submit"]');
    if (!btn) return;
    var bundle = btn.closest('[data-bundle-routine], [data-bundle-product]');
    if (!bundle) return;
    send('bundle_add_all_clicked', {
      bundle_product_id: bundle.getAttribute('data-product-id') || bundle.getAttribute('data-bundle-id') || '',
      bundle_name: bundle.getAttribute('data-bundle-name') || '',
      cart_item_count: bundle.querySelectorAll('[data-bundle-component], [data-bundle-item]').length
    });
  });

  /* ============================================================
     11. ITEM LIST (view_item_list + select_item)
     ============================================================ */

  var firedLists = {};

  function watchItemLists() {
    document.querySelectorAll('[data-product-list-id]').forEach(function (list) {
      if (list.__ga4ListWatched) return;
      list.__ga4ListWatched = true;
      var listId = list.getAttribute('data-product-list-id') || 'unknown';
      var listName = list.getAttribute('data-product-list-name') || listId;
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (!en.isIntersecting || firedLists[listId]) return;
          firedLists[listId] = true;
          var cards = list.querySelectorAll('[data-product-id]');
          var items = Array.from(cards).slice(0, 20).map(function (c, idx) {
            return {
              item_id: c.getAttribute('data-product-id') || '',
              item_name: c.getAttribute('data-product-title') || safeText(c.querySelector('h3, h4, .product-item__title, [data-product-title]')),
              item_brand: 'Laqqua',
              item_category: c.getAttribute('data-product-type') || '',
              item_list_id: listId,
              item_list_name: listName,
              price: parseFloat((c.getAttribute('data-product-price') || '0')) / 100 || null,
              index: idx + 1
            };
          });
          send('view_item_list', {
            item_list_id: listId,
            item_list_name: listName,
            items: items
          });
          obs.unobserve(en.target);
        });
      }, { threshold: 0.2 }).observe(list);
    });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-product-list-id] [data-product-id]');
    if (!card) return;
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    if (e.target.closest('button, [data-quick-add-btn]')) return;
    var list = card.closest('[data-product-list-id]');
    var siblings = Array.from(list.querySelectorAll('[data-product-id]'));
    var productId = card.getAttribute('data-product-id') || '';
    var listId = list.getAttribute('data-product-list-id');
    var listName = list.getAttribute('data-product-list-name') || listId;
    /* Persist context per propagare item_list_* a add_to_cart sul PDP successivo */
    rememberListContext(productId, listId, listName);
    send('select_item', {
      item_list_id: listId,
      item_list_name: listName,
      items: [{
        item_id: productId,
        item_name: card.getAttribute('data-product-title') || safeText(card.querySelector('.product-item__title, h3, h4')),
        item_brand: 'Laqqua',
        item_list_id: listId,
        item_list_name: listName,
        index: siblings.indexOf(card) + 1,
        price: parseFloat((card.getAttribute('data-product-price') || '0')) / 100 || null
      }]
    });
  });

  /* ============================================================
     12. BACK IN STOCK
     ============================================================ */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-notification-popup-button], [data-back-in-stock-trigger]');
    if (!trigger) return;
    var productEl = trigger.closest('[data-product-id]');
    send('back_in_stock_notification_form_open', {
      product_id: productEl ? productEl.getAttribute('data-product-id') : '',
      variant_id: trigger.getAttribute('data-variant-id') || ''
    });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('product-notification form[action*="/contact"], [data-notification-form]');
    if (!form) return;
    var productEl = form.closest('[data-product-id]');
    send('back_in_stock_notification_submitted', {
      product_id: productEl ? productEl.getAttribute('data-product-id') : '',
      variant_id: form.querySelector('[name="contact[variant_id]"]') ? form.querySelector('[name="contact[variant_id]"]').value : ''
    });
    /* Capture error response: Shopify mostra .errors in pagina dopo redirect */
    setTimeout(function () {
      var errEl = document.querySelector('product-notification .errors, [data-notification-form] .errors, .form-status--error');
      if (errEl && errEl.textContent.trim()) {
        send('back_in_stock_notification_error', {
          product_id: productEl ? productEl.getAttribute('data-product-id') : '',
          error_message: errEl.textContent.trim().slice(0, 200)
        });
      }
    }, 1500);
  });

  if (location.search.indexOf('contact_posted=true') !== -1 && document.querySelector('product-notification, [data-notification-form]')) {
    send('back_in_stock_notification_success', {});
  }

  /* ============================================================
     13. PRODUCT TABS / ACCORDION
     ============================================================ */

  var openTabAt = {};
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.tab-link, [data-tab-link]');
    if (!tab) return;
    /* Le pillole della griglia «Tuffati nel catalogo» hanno anche loro la
       classe .tab-link, ma NON sono schede di prodotto: hanno il loro evento
       (catalog_tab_selected, sezione 20-bis). Senza questa esclusione ogni
       cambio scheda in home finiva anche in product_tab_opened e gonfiava
       la quota «apre una scheda informativa» della PDP (scoperto 2026-08-18). */
    if (tab.closest('.nav-tabs__pills')) return;
    var name = safeText(tab.querySelector('span') || tab);
    var parent = tab.closest('ul, [role="tablist"], .product-tabs');
    var idx = parent ? Array.from(parent.children).indexOf(tab.tagName === 'LI' ? tab : tab.parentElement) + 1 : 0;
    var productEl = tab.closest('[data-product-id]');
    var productId = productEl ? productEl.getAttribute('data-product-id') : '';
    var prevKey = Object.keys(openTabAt)[0];
    if (prevKey && prevKey !== name) {
      send('product_tab_closed', {
        tab_name: prevKey,
        dwell_seconds: Math.round((Date.now() - openTabAt[prevKey]) / 1000),
        product_id: productId
      });
      delete openTabAt[prevKey];
    }
    openTabAt[name] = Date.now();
    send('product_tab_opened', {
      tab_name: name,
      tab_index: idx,
      product_id: productId
    });
  });

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('details')) return;
    if (d.closest('[data-collapsible], cart-drawer, [data-cart-drawer]')) return;
    var label = safeText(d.querySelector('summary'));
    if (!label) return;
    send(d.open ? 'accordion_opened' : 'accordion_closed', {
      label: label,
      page_type: getTemplate()
    });
  }, true);

  /* ============================================================
     14. GALLERIA DELLA SCHEDA PRODOTTO — schema 2.3 (24 ottobre 2026)

     Una sola fonte di verità: la foto attiva del tema. Sul telefono il
     carosello di product-images sposta la classe media--active (dito, frecce,
     miniature, tastiera, variante); sul computer le foto stanno tutte in
     griglia e conta quella che si vede sullo schermo.

     Eventi GA4:
     - product_image_selected: chi cambia foto. Fino al 2.2 partiva solo dal
       tocco su una miniatura (il 7% delle visite, mai lo scorrimento col dito):
       dal 2.3 conta ogni cambio fatto dalla persona.
     - view_product_image: una foto resta a schermo almeno 1 secondo. Una volta
       per foto per pagina: dice fin dove arrivano le persone.
     - product_zoom_opened: l'ingrandimento. Fino al 2.2 cercava un selettore
       che il tema non ha e non e' mai partito.
     Parametri: product_handle, image_position (1 = prima foto; Yuka e la
     recensione contano come foto), image_name (nome del file senza estensione
     e codice, oppure «yuka», «recensione»), trigger (initial | swipe | arrow |
     thumbnail | keyboard | scroll | other; dal 24/10 sera anche lightbox
     all'apertura della finestra ingrandita e lightbox_<gesto> sfogliando lì).

     Il tempo per foto (millisecondi a schermo) va solo al contatore nostro
     con l'evento «galleria» (lq-consenso.js ascolta lq:galleria): vede tutte
     le visite, anche senza consenso, e sta nella stessa sessione delle
     aggiunte al carrello. Un riepilogo a GA4 all'uscita si perderebbe o si
     doppierebbe (chi cambia app e torna): per questo non c'è.
     Manuale: docs/GALLERIE.md §10.
     ============================================================ */

  (function galleria() {
    if (getTemplate().indexOf('product') === -1) return;
    var VISTA_MS = 1000;
    var INPUT_MS = 1500;
    var ctxP = window.__laqquaProductCtx || {};
    var handle = ctxP.handle || (location.pathname.split('/products/')[1] || '').split('/')[0];
    var stato = {};
    var maxPos = 0, zoom = 0, tocchi = 0;
    var ultimoInput = null, ultimoInputT = 0;
    var radice, slides, carosello = false, attiva = null, inVista = [];
    // finestra ingrandita (zoom.js, evento lq:finestra): la foto aperta lì
    // dentro, e fino a quando ignorare il riallineamento del carosello.
    var inFinestra = null, silenzioFino = 0;

    function nomeFoto(slide) {
      if (slide.classList.contains('lqys-slide')) return 'yuka';
      if (slide.classList.contains('lqrs-slide')) return 'recensione';
      if (slide.getAttribute('data-type') === 'video') return 'video';
      var img = slide.querySelector('img');
      var src = img ? (img.getAttribute('data-src') || img.currentSrc || img.src || '') : '';
      var file = src.split('?')[0].split('/').pop() || '';
      file = file.replace(/\.[a-z0-9]{2,4}$/i, '')
                 .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '');
      return file.slice(0, 60) || 'sconosciuta';
    }
    function idFoto(slide) {
      var m = (slide.getAttribute('data-media-id') || '').split('-').pop();
      return /^\d{6,20}$/.test(m) ? m : '';
    }
    function voce(slide) {
      var p = slides.indexOf(slide) + 1;
      if (!stato[p]) stato[p] = { n: p, f: nomeFoto(slide), id: idFoto(slide), ms: 0, inizio: 0, vista: false, timer: null };
      return stato[p];
    }
    function inizia(slide, trigger) {
      if (!slide || document.visibilityState === 'hidden') return;
      var v = voce(slide);
      if (v.inizio) return;
      v.inizio = Date.now();
      if (v.vista) return;
      v.timer = setTimeout(function () {
        v.timer = null;
        if (!v.inizio || v.vista) return;
        v.vista = true;
        if (v.n > maxPos) maxPos = v.n;
        send('view_product_image', {
          product_handle: handle, image_position: v.n, image_name: v.f, trigger: trigger
        });
      }, VISTA_MS);
    }
    function ferma(slide) {
      if (!slide) return;
      var v = voce(slide);
      if (v.timer) { clearTimeout(v.timer); v.timer = null; }
      if (!v.inizio) return;
      v.ms += Date.now() - v.inizio;
      v.inizio = 0;
    }
    function gesto() {
      return (ultimoInput && Date.now() - ultimoInputT < INPUT_MS) ? ultimoInput : 'other';
    }
    function segna(tipo) { ultimoInput = tipo; ultimoInputT = Date.now(); }

    // Il riepilogo per il contatore nostro parte a ogni uscita (pagina nascosta o
    // chiusa) con lo stesso codice di pagina: i millisecondi si sommano, il
    // database tiene solo l'ultimo per codice. Così chi cambia app e torna non
    // perde niente e non conta due volte. A GA4 bastano gli eventi per foto.
    var pv = Math.random().toString(36).slice(2, 10), ultimoInvio = '';
    function riepilogo() {
      if (!slides) return;
      slides.forEach(function (s) { ferma(s); });
      var lista = [];
      Object.keys(stato).forEach(function (k) {
        var v = stato[k];
        if (v.ms >= 300) lista.push({ n: v.n, f: v.f.slice(0, 50), id: v.id || undefined, ms: v.ms });
      });
      if (!lista.length) return;
      lista.sort(function (a, b) { return a.n - b.n; });
      var dati = { pv: pv, pr: handle, mx: maxPos, fz: zoom, ft: tocchi, g: lista.slice(0, 20) };
      var firma = JSON.stringify(dati);
      if (firma === ultimoInvio) return;
      ultimoInvio = firma;
      try { window.dispatchEvent(new CustomEvent('lq:galleria', { detail: dati })); } catch (e) {}
    }

    function avvia() {
      radice = document.querySelector('product-images');
      var contenitore = radice ? radice.querySelector('.product__slides') : null;
      if (!contenitore) return false;
      slides = Array.prototype.slice.call(contenitore.querySelectorAll(':scope > .product__slide'));
      if (!slides.length) return false;
      carosello = slides.length > 1 && getComputedStyle(slides[1]).visibility === 'hidden';

      // il gesto che ha mosso la foto: l'ultimo input entro 1,5 secondi
      contenitore.addEventListener('touchend', function () { segna('swipe'); }, { passive: true, capture: true });
      contenitore.addEventListener('mouseup', function () { segna('swipe'); }, true);
      contenitore.addEventListener('keyup', function (e) {
        if (e.code === 'ArrowLeft' || e.code === 'ArrowRight') segna('keyboard');
      }, true);
      document.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('product-images .slider__arrows')) segna('arrow');
        else if (e.target.closest('product-thumbs [data-thumb-link], product-thumbs [data-media-id]')) { segna('thumbnail'); tocchi++; }
        var z = e.target.closest('product-images [data-zoom-image]');
        if (z && !radice.classList.contains('is-dragging')) {
          zoom++;
          var sl = z.closest('.product__slide');
          if (sl) send('product_zoom_opened', {
            product_handle: handle, image_position: slides.indexOf(sl) + 1, image_name: nomeFoto(sl)
          });
        }
      }, true);

      if (carosello) {
        attiva = contenitore.querySelector(':scope > .product__slide.media--active') || slides[0];
        inizia(attiva, 'initial');
        var mo = new MutationObserver(function () {
          var nuova = contenitore.querySelector(':scope > .product__slide.media--active');
          if (!nuova || nuova === attiva) return;
          // il carosello si muove da solo: finestra aperta, o la chiusura che lo
          // riporta sulla foto guardata lì dentro. Non è un gesto sulla pagina.
          if (inFinestra || Date.now() < silenzioFino) {
            ferma(attiva);
            attiva = nuova;
            if (!inFinestra) inizia(attiva, 'other');
            return;
          }
          var g = gesto();
          ferma(attiva);
          attiva = nuova;
          inizia(attiva, g);
          if (g !== 'other') {
            send('product_image_selected', {
              product_handle: handle, image_position: slides.indexOf(nuova) + 1,
              image_name: nomeFoto(nuova), trigger: g
            });
          }
        });
        slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
      } else if ('IntersectionObserver' in window) {
        var primo = true;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var s = en.target;
            if (en.isIntersecting && en.intersectionRatio >= 0.6) {
              inVista.push(s);
              if (!inFinestra) inizia(s, primo && slides.indexOf(s) === 0 ? 'initial' : 'scroll');
            }
            else { inVista = inVista.filter(function (x) { return x !== s; }); ferma(s); }
          });
          primo = false;
        }, { threshold: [0, 0.6] });
        slides.forEach(function (s) { io.observe(s); });
      }

      // pagina nascosta: si ferma il cronometro e parte il riepilogo (una volta).
      // Pagina che torna visibile, o che era nascosta all'apertura (precaricata):
      // si riprende la foto a schermo, altrimenti la prima vista non si conterebbe mai.
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') { slides.forEach(function (s) { ferma(s); }); riepilogo(); return; }
        var nessuna = !Object.keys(stato).some(function (k) { return stato[k].vista; });
        if (inFinestra) inizia(inFinestra, 'lightbox');
        else if (carosello) inizia(attiva, nessuna ? 'initial' : 'other');
        else inVista.forEach(function (s) { inizia(s, nessuna && slides.indexOf(s) === 0 ? 'initial' : 'scroll'); });
      });
      window.addEventListener('pagehide', riepilogo);

      // Finestra ingrandita (zoom.js). Mentre è aperta la foto sotto, in pagina,
      // non è a schermo: il suo cronometro si ferma e corre quello della foto
      // nella finestra. Ogni foto vista lì dentro conta come le altre (stessa
      // posizione: Yuka e recensione ci sono anche nella finestra), con trigger
      // «lightbox» all'apertura e «lightbox_<gesto>» quando si sfoglia.
      window.addEventListener('lq:finestra', function (e) {
        var d = e.detail || {};
        var s = null;
        for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === d.id) { s = slides[i]; break; }
        if (d.stato === 'aperta') {
          // aperta col pizzico (zoom.js): non passa dal clic contato sopra
          if (d.gesto === 'pinch' && s) {
            zoom++;
            send('product_zoom_opened', {
              product_handle: handle, image_position: slides.indexOf(s) + 1, image_name: nomeFoto(s), trigger: 'pinch'
            });
          }
          if (carosello) ferma(attiva); else inVista.forEach(function (x) { ferma(x); });
          inFinestra = s;
          inizia(inFinestra, 'lightbox');
        } else if (d.stato === 'foto') {
          ferma(inFinestra);
          inFinestra = s;
          if (!s) return;
          var g = 'lightbox_' + (d.gesto || 'other');
          inizia(s, g);
          send('product_image_selected', {
            product_handle: handle, image_position: slides.indexOf(s) + 1, image_name: nomeFoto(s), trigger: g
          });
        } else if (d.stato === 'chiusa') {
          ferma(inFinestra);
          inFinestra = null;
          silenzioFino = Date.now() + 1500;
          if (carosello) {
            var ora = contenitore.querySelector(':scope > .product__slide.media--active') || attiva;
            attiva = ora;
            inizia(attiva, 'other');
          }
          // sul computer riparte l'IntersectionObserver: la griglia è di nuovo a
          // schermo e zoom.js ci ha appena scorso sopra se serviva
          else inVista.forEach(function (x) { inizia(x, 'scroll'); });
        }
      });
      return true;
    }

    if (!avvia()) {
      // la galleria a volte arriva dopo questo file: un secondo tentativo basta
      document.addEventListener('DOMContentLoaded', function () { if (!slides) avvia(); });
    }
  })();

  /* ============================================================
     15. VIDEO play/pause
     ============================================================ */

  function attachVideoTracking(video) {
    if (video.__ga4VideoWatched) return;
    video.__ga4VideoWatched = true;
    var section = video.closest('[data-section-id]');
    var videoType = video.closest('video-background') ? 'background'
                  : video.closest('video-popup, .pswp') ? 'popup'
                  : 'inline';
    var videoId = video.getAttribute('data-video-id') || (video.querySelector('source') && video.querySelector('source').src) || video.src || '';
    var playedOnce = false;
    var completed = false;
    video.addEventListener('play', function () {
      if (playedOnce) return;
      playedOnce = true;
      send('video_play', {
        video_id: videoId,
        video_type: videoType,
        section_id: section ? section.getAttribute('data-section-id') : ''
      });
    });
    video.addEventListener('pause', function () {
      if (video.ended || completed) return;
      send('video_pause', {
        video_id: videoId,
        watch_seconds: Math.round(video.currentTime),
        watch_percent: video.duration ? Math.round((video.currentTime / video.duration) * 100) : 0
      });
    });
    video.addEventListener('timeupdate', function () {
      if (completed || !video.duration) return;
      if (video.currentTime / video.duration >= 0.9) {
        completed = true;
        send('video_complete', {
          video_id: videoId,
          watch_seconds: Math.round(video.currentTime),
          watch_percent: Math.round((video.currentTime / video.duration) * 100)
        });
      }
    });
  }

  function scanVideos() {
    document.querySelectorAll('video').forEach(attachVideoTracking);
  }

  /* ============================================================
     16. MOBILE MENU (riscritto il 15/10/2026)
     Prima: mobile_menu_opened non partiva mai (guardava <mobile-menu>,
     ma la classe is-open la prende <header-drawer>) e menu_level diceva
     sempre «primary» (cercava .submenu, che il tema non usa).
     Parametri riusati fra quelli GIA' registrati come dimensioni in GA4,
     cosi' si leggono in dashboard da subito:
       menu_level      livello_1 / livello_2 / livello_3
       block_type      categorie / aiuto / laqqua / social / barra_categorie
       tab_name        il percorso del pannello («Skincare › Per tipo di pelle»)
       grid_slot       la posizione della voce nel suo elenco (1 = prima)
       close_method    x / sfondo / esc / voce (chiusura del cassetto)
       trigger         hamburger
     ============================================================ */

  var menuAperto = 0;
  var menuScelto = false;
  var menuPannelli = 0;
  var menuChiusura = '';

  function livelloMenu(el) {
    var n = 0, p = el;
    while (p && (p = p.parentElement)) {
      if (p.classList && p.classList.contains('sliderule__panel')) n++;
      if (p.matches && p.matches('mobile-menu, header-drawer')) break;
    }
    return 'livello_' + (n + 1);
  }

  function percorsoMenu(el) {
    var nomi = [], p = el;
    while (p && (p = p.parentElement)) {
      if (p.classList && p.classList.contains('sliderule__panel')) {
        var t = p.querySelector(':scope > .sliderow--back .sliderow__title');
        if (t) nomi.unshift((t.textContent || '').trim().replace(/\s+/g, ' '));
      }
      if (p.matches && p.matches('mobile-menu, header-drawer')) break;
    }
    return nomi.join(' › ').slice(0, 80);
  }

  function bloccoMenu(el) {
    var blocco = el.closest('.mobile-menu__block');
    if (!blocco) return 'menu';
    if (blocco.classList.contains('mobile-menu__block--menu')) return 'categorie';
    if (blocco.classList.contains('mobile-menu__block--socials')) return 'social';
    var prec = blocco.previousElementSibling;
    while (prec && !prec.classList.contains('mobile-menu__block--text')) prec = prec.previousElementSibling;
    var nome = prec ? (prec.textContent || '').trim().toLowerCase() : '';
    return nome ? nome.replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 30) : 'link';
  }

  function posizione(el, selettore) {
    var lista = el.parentElement;
    while (lista && lista.children.length < 2) lista = lista.parentElement;
    if (!lista) return 1;
    var voci = Array.prototype.filter.call(lista.querySelectorAll(selettore), function (x) {
      return x.offsetParent !== null;
    });
    var i = voci.indexOf(el);
    return i >= 0 ? i + 1 : 1;
  }

  function instrumentMobileMenu() {
    var drawer = document.querySelector('header-drawer.drawer--header');
    if (!drawer || drawer.__ga4Instrumented) return;
    drawer.__ga4Instrumented = true;
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('is-open');
      if (isOpen && !menuAperto) {
        menuAperto = Date.now();
        menuScelto = false;
        menuPannelli = 0;
        menuChiusura = '';
        send('mobile_menu_opened', { trigger: 'hamburger', page_type: getTemplate() });
      } else if (!isOpen && menuAperto) {
        send('mobile_menu_closed', {
          close_method: menuScelto ? 'voce' : (menuChiusura || 'altro'),
          has_clicked: menuScelto ? 'si' : 'no',
          submenus_opened: menuPannelli,
          dwell_seconds: Math.round((Date.now() - menuAperto) / 1000)
        });
        menuAperto = 0;
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) menuChiusura = 'x';
      else if (e.target.closest('[data-drawer-underlay]')) menuChiusura = 'sfondo';
    }, true);
    document.addEventListener('keyup', function (e) {
      if (menuAperto && (e.key === 'Escape' || e.code === 'Escape')) menuChiusura = 'esc';
    }, true);
  }

  /* Sottomenu aperto: quale e a che livello */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('header-drawer [data-sliderule-open]');
    if (!b) return;
    menuPannelli++;
    var nome = b.querySelector('.sliderow__title > span:first-of-type');
    send('mobile_menu_submenu_opened', {
      menu_item_text: ((nome || b).textContent || '').trim().replace(/\s+/g, ' ').slice(0, 60),
      menu_level: livelloMenu(b),
      tab_name: percorsoMenu(b),
      grid_slot: posizione(b.closest('.sliderule__wrapper') || b, ':scope > .sliderule__wrapper')
    });
  });

  /* Voce scelta nel cassetto */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('header-drawer a, mobile-menu a, [data-mobile-menu] a');
    if (!link) return;
    if (link.closest('[data-search-form], header-search-popdown')) return;
    menuScelto = true;
    var wrap = link.closest('.sliderule__wrapper') || link.closest('li') || link;
    send('menu_item_clicked', {
      menu_item_text: (link.getAttribute('data-lq-voce') || safeText(link) || link.getAttribute('aria-label') || '').slice(0, 60),
      menu_item_url: link.getAttribute('href') || '',
      menu_level: livelloMenu(link),
      block_type: bloccoMenu(link),
      tab_name: percorsoMenu(link),
      grid_slot: posizione(wrap, wrap.matches('li') ? ':scope > li' : ':scope > .sliderule__wrapper'),
      menu_section: 'mobile_menu'
    });
  });

  /* Barra delle categorie sotto il logo (telefono) */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.header__mobile__nav__scroller a');
    if (!link) return;
    var voci = Array.prototype.slice.call(document.querySelectorAll('.header__mobile__nav__scroller a'));
    send('menu_item_clicked', {
      menu_item_text: (safeText(link) || '').slice(0, 60),
      menu_item_url: link.getAttribute('href') || '',
      menu_level: 'livello_1',
      block_type: 'barra_categorie',
      grid_slot: voci.indexOf(link) + 1,
      menu_section: 'barra_categorie'
    });
  });

  /* ============================================================
     17. CONTACT FORM
     ============================================================ */

  function watchContactForms() {
    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      if (form.__ga4ContactWatched) return;
      if (!form.querySelector('textarea[name="contact[body]"], textarea[name*="message"]')) return;
      if (form.closest('product-notification, newsletter-component, footer')) return;
      form.__ga4ContactWatched = true;

      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          send('contact_form_view', { page_path: location.pathname });
          obs.unobserve(en.target);
        });
      }, { threshold: 0.4 }).observe(form);

      form.addEventListener('submit', function () {
        send('contact_form_submitted', {
          field_count: form.querySelectorAll('input, textarea, select').length,
          has_message: !!(form.querySelector('textarea') && form.querySelector('textarea').value.trim())
        });
      });
    });
  }

  if (location.search.indexOf('contact_posted=true') !== -1 && getTemplate() === 'contact') {
    send('contact_form_success', { page_path: location.pathname });
  }

  /* ============================================================
     18. POPUP / MODAL
     ============================================================ */

  var popupOpenAt = {};
  function popupTypeOf(p) {
    if (p.matches('product-notification, [data-notification-popup]')) return 'product_notification';
    if (p.matches('[data-age-gate]')) return 'age_gate';
    if (p.matches('[data-promo-popup], [data-newsletter-popup]')) return 'promo';
    return p.getAttribute('data-popup-type') || 'generic';
  }

  function watchPopups() {
    document.querySelectorAll('popup-component, [data-popup], product-notification').forEach(function (p) {
      if (p.__ga4PopupWatched) return;
      p.__ga4PopupWatched = true;
      var type = popupTypeOf(p);
      var popupId = p.id || p.getAttribute('data-popup-id') || type;
      new MutationObserver(function () {
        var isOpen = !p.hidden && !p.hasAttribute('inert') &&
                     (p.classList.contains('is-open') || p.classList.contains('is-visible') ||
                      p.hasAttribute('open') || p.getAttribute('aria-hidden') === 'false');
        if (isOpen && !popupOpenAt[popupId]) {
          popupOpenAt[popupId] = Date.now();
          send('popup_view', { popup_type: type, popup_id: popupId });
        } else if (!isOpen && popupOpenAt[popupId]) {
          send('popup_dismissed', {
            popup_type: type,
            popup_id: popupId,
            dwell_seconds: Math.round((Date.now() - popupOpenAt[popupId]) / 1000)
          });
          delete popupOpenAt[popupId];
        }
      }).observe(p, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden', 'hidden', 'inert'] });
    });
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('popup-component a, popup-component button[type="button"]:not([data-popup-close])');
    if (!cta) return;
    var p = cta.closest('popup-component, [data-popup]');
    if (!p) return;
    send('popup_cta_clicked', {
      popup_type: popupTypeOf(p),
      popup_id: p.id || '',
      cta_label: safeText(cta),
      cta_href: cta.getAttribute('href') || ''
    });
  });

  /* ============================================================
     19. COUNTDOWN expiry
     ============================================================ */

  document.addEventListener('theme:countdown:expire', function (e) {
    var t = e.target;
    var ann = t.closest('announcement-bar, [data-announcement-id]');
    send('countdown_expired', {
      countdown_id: t.id || t.getAttribute('data-countdown-id') || '',
      announcement_id: ann && ann.getAttribute ? (ann.getAttribute('data-announcement-id') || '') : ''
    });
  });

  /* ============================================================
     20. SHARE / COMPARE / ANNOUNCEMENT (BASSA)
     ============================================================ */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('share-button [data-share-button], [data-share-button]');
    if (!btn) return;
    var hasNativeShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
    var productEl = btn.closest('[data-product-id]');
    send('share_clicked', {
      share_method: hasNativeShare ? 'native_share' : 'copy_to_clipboard',
      page_url: location.href,
      product_id: productEl ? productEl.getAttribute('data-product-id') : '',
      page_type: getTemplate()
    });
  });

  var compareDebounced = debounce(function (pct, productId) {
    send('compare_images_interaction', { slider_position_percent: pct, product_id: productId });
  }, 1200);

  document.addEventListener('input', function (e) {
    var range = e.target.closest('compare-images [data-range-input], [data-compare-range]');
    if (!range) return;
    var productEl = range.closest('[data-product-id]');
    compareDebounced(parseFloat(range.value) || 0, productEl ? productEl.getAttribute('data-product-id') : '');
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('announcement-bar a, [data-announcement] a, .announcement a');
    if (!link) return;
    var ann = link.closest('announcement-bar, [data-announcement-id]');
    send('announcement_link_clicked', {
      link_text: safeText(link),
      link_url: link.getAttribute('href') || '',
      announcement_id: ann && ann.getAttribute ? (ann.getAttribute('data-announcement-id') || '') : ''
    });
  });

  /* ============================================================
     21. PAGE SCROLL DEPTH
     NOTA: GA4 Enhanced Measurement traccia 'scroll' automatico al 90%.
     L'evento 'scroll_depth' qui e' arricchito con page_type e altri
     parametri. Per evitare doppio tracking del 90%, DISATTIVA
     "Scrolls" in GA4 → Admin → Data Streams → Web → Enhanced
     Measurement → Toggle off "Scrolls". Sostituito dalla logica custom.
     ============================================================ */

  (function scrollDepth() {
    var tpl = getTemplate();
    if (['product', 'collection', 'index'].indexOf(tpl) === -1) return;

    var thresholds = [25, 50, 75, 90];
    var fired = {};
    var startTime = Date.now();

    function check() {
      var docH = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight
      );
      var winH = window.innerHeight;
      var scrollY = window.scrollY || window.pageYOffset;
      var scrollable = docH - winH;
      if (scrollable <= 0) return;
      var pct = Math.round((scrollY / scrollable) * 100);

      thresholds.forEach(function (t) {
        if (pct >= t && !fired[t]) {
          fired[t] = true;
          send('scroll_depth', {
            percent: t,
            page_type: tpl,
            page_path: window.location.pathname,
            time_on_page_seconds: Math.round((Date.now() - startTime) / 1000)
          });
        }
      });

      if (Object.keys(fired).length === thresholds.length) {
        window.removeEventListener('scroll', throttled);
      }
    }

    var ticking = false;
    function throttled() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        check();
        setTimeout(function () { ticking = false; }, 200);
      });
    }

    window.addEventListener('scroll', throttled, { passive: true });
    setTimeout(check, 500);
  })();

  /* ============================================================
     22. BOOTSTRAP + SINGLE MUTATION OBSERVER
     ============================================================ */

  /* Bootstrap cart snapshot */
  origFetch.call(window, '/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.items) cartSnapshot = snapshotFromCart(cart);
    })
    .catch(function () {});

  function scanAll() {
    initNavTabsState();
    osservaGriglie();
    instrumentDrawer();
    watchGiftBlock();
    watchGiftReminder();
    watchCartUpsells();
    watchNewsletterForms();
    watchBundle();
    watchItemLists();
    watchContactForms();
    watchPopups();
    instrumentMobileMenu();
    scanVideos();
  }

  /* ============================================================
     20. MODULI DELLA HOME E DELLE PAGINE (nuovo, 2026-07-30)

     Il buco piu' grande del tracciamento: nessun clic dell'hero, della strip
     USP, delle categorie in evidenza, dei caroselli, delle recensioni, del
     blocco impatto e del blog era misurato. In dashboard la scheda «Hero e
     bottoni della home» diceva «non tracciato», e non sapevamo se quei
     bottoni servissero a qualcosa.

     Perche' i nomi dei parametri sono questi. Un parametro nuovo in GA4
     serve a niente finche' non lo si registra come custom dimension (e la
     property e' vicina al limite). Quindi si riusano SOLO nomi che GA4 sa
     gia' interrogare, verificati con la sonda dei metadati:
       block_type      → che tipo di modulo e' (hero, categorie, carosello…)
       menu_item_text  → il testo del bottone o del link
       menu_item_url   → dove porta
       section_id      → l'id della sezione Shopify (per distinguere due
                         caroselli diversi nella stessa pagina)
       page_type       → su che tipo di pagina siamo
     Cosi' il dato e' leggibile in dashboard da subito, senza aspettare che
     qualcuno apra GA4.
     ============================================================ */

  /* Dal contenitore di sezione al nome del modulo. La home NON ha
     `data-section-type` (verificato sul DOM live): l'unico segnale e' la
     classe della sezione. */
  function moduloDiSezione(sec) {
    if (!sec) return 'altro';
    var c = sec.className || '';
    var id = sec.getAttribute('data-section-id') || '';
    if (/index-hero/.test(c)) return 'hero';
    if (/lq-yuka-home/.test(c)) return 'yuka';
    if (/index-collections-list/.test(c)) return 'categorie';
    if (/index-products/.test(c)) return 'carosello_prodotti';
    if (/laqqua-impact-section/.test(c)) return 'impatto';
    if (/blog-section/.test(c)) return 'blog';
    if (/index-image-text|index-double/.test(c)) return 'immagine_testo';
    if (/index-rte/.test(c)) return 'testo';
    if (/faq/.test(c)) return 'faq';
    if (/site-footer|supporting-menu/.test(c)) return 'footer';
    if (/announcement/.test(c)) return 'annuncio';
    /* i blocchi custom-code sono riconoscibili solo dall'id della sezione */
    if (/uspbar/i.test(id)) return 'strip_usp';
    if (/JyQQD7/i.test(id)) return 'recensioni';
    if (/custom_code/i.test(id)) return 'blocco_custom';
    return 'altro';
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href], button');
    if (!link) return;

    /* Fuori: header, menu, cassetto carrello e schede prodotto hanno gia' i
       loro eventi dedicati; contarli anche qui sarebbe un doppione. */
    if (link.closest('header, header-component, mobile-menu, cart-drawer, [data-cart-drawer], .cart-drawer')) return;
    if (link.closest('[data-product-list-id] [data-product-id], grid-item')) return;
    if (link.closest('[data-collapsible-trigger], [data-discount-toggle], [data-quick-add-btn], form[action*="/cart/add"]')) return;

    var sec = link.closest('[data-section-id]');
    if (!sec) return;
    var modulo = moduloDiSezione(sec);
    if (modulo === 'altro') return;

    var payload = {
      block_type: modulo,
      menu_item_text: safeText(link).slice(0, 60) || (link.getAttribute('aria-label') || '').slice(0, 60),
      menu_item_url: link.getAttribute('href') || '',
      section_id: sec.getAttribute('data-section-id') || '',
      page_type: getTemplate()
    };

    /* tile_id NON sta piu' qui: i riquadri della griglia hanno il loro evento
       dedicato (catalog_grid_tile_selected, §20-bis) con grid_slot, posizione e
       tipo di destinazione. home_module_clicked resta il censimento generale
       della home.
       ⚠️ MAI sommare i clic di questo evento con quelli di tile_selected in
       dashboard: i riquadri della griglia sono contati in entrambi. */
    send('home_module_clicked', payload);
  });

  /* 20-ter. Modulo «Punteggi Yuka in home» (section-yuka-home.liquid, 11 ott
     2026): impression dopo 1 secondo di permanenza, una per pageview. Stessa
     regola della griglia: sentinella = intestazione del modulo al 30%, non
     l'intero modulo, che su telefono e' quasi alto quanto lo schermo. */
  (function yukaHomeImpression() {
    if (!('IntersectionObserver' in window)) return;
    var timer = null;
    var visto = {};
    function osserva() {
      var sent = document.querySelector('.lq-yuka-home .lqyh__text');
      if (!sent || sent.__yukaObs) return;
      sent.__yukaObs = true;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            if (timer || visto[pageviewId]) return;
            timer = setTimeout(function () {
              timer = null;
              if (visto[pageviewId]) return;
              visto[pageviewId] = true;
              sendBoth('yuka_module_viewed', { page_type: getTemplate() });
            }, IMPRESSION_DWELL_MS);
          } else if (timer) {
            clearTimeout(timer);
            timer = null;
          }
        });
      }, { threshold: 0.3 }).observe(sent);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', osserva);
    else osserva();
  })();

  /* ============================================================
     20-bis. GRIGLIA DI NAVIGAZIONE «Tuffati nel catalogo» (v5, 2026-08-18)

     ⚠️ LA HOME NE HA TRE, non una. templates/index.json renderizza tre
     section-nav-tabs (posizioni 6, 24, 25) quasi identiche. Senza distinguerle
     le impression collassano e i clic si sommano. grid_slot le separa,
     derivato dall'ORDINE DOM: grid-1, grid-2, grid-3.

     Tre eventi, tutti mandati anche a Umami (fonte primaria del modulo):
       catalog_grid_viewed        impression, chiave (pageview x slot x scheda)
       catalog_grid_tile_selected clic su un riquadro
       catalog_grid_tab_selected  cambio scheda (ex catalog_tab_selected)

     L'impression richiede 1 SECONDO di permanenza continua: senza, si contano
     anche gli scroll a 3000px/s che non hanno visto niente, e a ~30
     impression/giorno quel rumore pesa piu' di ogni raffinatezza a valle.
     Sentinella = prima card del pannello, threshold 0.3: MAI 0.5 sull'intera
     griglia, che su mobile e' piu' alta del viewport e non scatterebbe mai.

     ⚠️ I pannelli non correnti NON sono display:none: il tema li lascia
     display:block con visibility:hidden e opacity:0, quindi intersecano tutti
     e tre. Verificato sul sito live: affidarsi alla geometria farebbe partire
     impression di schede che nessuno ha mai aperto. Per questo la condizione e'
     esplicita: il pannello deve essere .current E la sentinella dev'essere
     visibile per almeno il 30%. Al cambio scheda la geometria non cambia, quindi
     l'observer non richiama: il nuovo pannello va valutato a mano.
     ============================================================ */

  var IMPRESSION_DWELL_MS = 1000;
  var impressionViste = {};   /* pageviewId|slot|scheda -> true */
  var impressionTimer = {};   /* slot|scheda -> timer          */
  var ioGriglia = null;

  function grigliaDi(el) { return el.closest ? el.closest('tabs-component.nav-tabs') : null; }

  function slotDi(el) {
    var g = grigliaDi(el);
    return (g && g.getAttribute('data-grid-slot')) || 'grid-?';
  }

  function assegnaGridSlot() {
    var griglie = document.querySelectorAll('tabs-component.nav-tabs');
    Array.prototype.forEach.call(griglie, function (g, i) {
      if (!g.getAttribute('data-grid-slot')) g.setAttribute('data-grid-slot', 'grid-' + (i + 1));
    });
  }

  function pannelloVisibile(pan) {
    if (!pan || !pan.classList.contains('current')) return false;
    var sent = pan.__gridSent;
    if (!sent) return false;
    var r = sent.getBoundingClientRect();
    if (!r.height) return false;
    var visibile = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
    return (visibile / r.height) >= 0.3;
  }

  function emettiImpression(pan) {
    var slot = slotDi(pan);
    var tab = pan.getAttribute('data-axis-slug') || '';
    var chiave = pageviewId + '|' + slot + '|' + tab;
    if (impressionViste[chiave]) return;
    impressionViste[chiave] = true;
    sendBoth('catalog_grid_viewed', {
      grid_slot: slot,
      tab_name: tab,
      layout_version: pan.getAttribute('data-layout-version') || '',
      creative_version: pan.getAttribute('data-creative-version') || '',
      page_type: getTemplate()
    });
  }

  /* Unico punto di decisione: visibile e corrente -> arma il timer di
     permanenza; altrimenti disarma. Chiamato sia dall'observer (cambio di
     geometria) sia dal cambio scheda (cambio di stato a geometria ferma). */
  function valutaPannello(pan) {
    if (!pan) return;
    var k = pan.__gridKey;
    if (pannelloVisibile(pan)) {
      if (impressionTimer[k]) return;
      impressionTimer[k] = setTimeout(function () {
        impressionTimer[k] = null;
        if (pannelloVisibile(pan)) emettiImpression(pan);
      }, IMPRESSION_DWELL_MS);
    } else if (impressionTimer[k]) {
      clearTimeout(impressionTimer[k]);
      impressionTimer[k] = null;
    }
  }

  function osservaGriglie() {
    if (!('IntersectionObserver' in window)) return;
    assegnaGridSlot();
    if (!ioGriglia) {
      ioGriglia = new IntersectionObserver(function (entries) {
        Array.prototype.forEach.call(entries, function (en) {
          valutaPannello(en.target.__gridPanel);
        });
      }, { threshold: [0, 0.3, 0.6] });
    }
    var pannelli = document.querySelectorAll('tabs-component.nav-tabs .nav-tabs__panel');
    Array.prototype.forEach.call(pannelli, function (pan) {
      if (pan.__gridWatched) return;
      pan.__gridWatched = true;
      var sent = pan.querySelector('.grid-item') || pan;
      sent.__gridPanel = pan;
      pan.__gridSent = sent;
      pan.__gridKey = slotDi(pan) + '|' + (pan.getAttribute('data-axis-slug') || '');
      ioGriglia.observe(sent);
      valutaPannello(pan);
    });
  }

  /* ---- Clic su un riquadro -------------------------------------------
     Listener unico delegato, dati letti da attributi precalcolati in Liquid:
     zero getBoundingClientRect nel click (la home ha gia' INP rosso).
     Nel click SOLO scrittura localStorage (sincrona, deve precedere la
     navigazione) + invio. Nient'altro nella finestra di interazione. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('tabs-component.nav-tabs a.collection-item__content[data-tile-id]');
    if (!a) return;
    var pan = a.closest('.nav-tabs__panel');
    var slot = slotDi(a);
    var tileId = a.getAttribute('data-tile-id') || '';

    setLastClickNav('grid:' + slot + ':' + tileId);

    sendBoth('catalog_grid_tile_selected', {
      grid_slot: slot,
      tab_name: (pan && pan.getAttribute('data-axis-slug')) || '',
      tile_id: tileId.slice(0, 60),
      tile_position: parseInt(a.getAttribute('data-tile-pos'), 10) || 0,
      tile_dest_type: a.getAttribute('data-tile-dest') || '',
      layout_version: (pan && pan.getAttribute('data-layout-version')) || '',
      creative_version: (pan && pan.getAttribute('data-creative-version')) || '',
      page_type: getTemplate()
    });
  });

  /* ---- Cambio scheda --------------------------------------------------
     Le pillole sono <li>, quindi il listener dei moduli (che guarda a[href] e
     button) non le vede. Scatta solo al cambio vero: lo stato per griglia parte
     dalla pillola .current al caricamento. Il cambio via trascinamento arriva
     comunque, finisce in un click programmatico sulla pillola di arrivo. */
  var tabAttivaPerSezione = {};

  function initNavTabsState() {
    assegnaGridSlot();
    var pillole = document.querySelectorAll('.nav-tabs__pill.current[data-axis-slug]');
    Array.prototype.forEach.call(pillole, function (p) {
      var k = slotDi(p);
      if (!(k in tabAttivaPerSezione)) tabAttivaPerSezione[k] = p.getAttribute('data-axis-slug') || '';
    });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('.nav-tabs__pill[data-axis-slug]');
    if (!pill) return;
    var slot = slotDi(pill);
    var slug = pill.getAttribute('data-axis-slug') || '';
    if (tabAttivaPerSezione[slot] === slug) return;   /* stessa scheda: non e' un cambio */
    tabAttivaPerSezione[slot] = slug;
    /* La geometria non cambia (i pannelli restano tutti display:block): senza
       questa rivalutazione l'impression della scheda appena aperta non
       partirebbe mai, e quella della scheda lasciata resterebbe armata. */
    var g = grigliaDi(pill);
    if (g) {
      Array.prototype.forEach.call(g.querySelectorAll('.nav-tabs__panel'), function (pan) {
        setTimeout(function () { valutaPannello(pan); }, 0);
      });
    }
    sendBoth('catalog_grid_tab_selected', {
      grid_slot: slot,
      tab_name: slug,
      page_type: getTemplate()
    });
  });

  /* ---- Le altre due strade di navigazione ------------------------------
     Servono per confrontare griglia / menu / ricerca. Descrittivo, non
     causale: le persone si auto-selezionano. In capture cosi' gira prima del
     listener della griglia, che pero' esce subito sulle proprie ancore.
     MAI il termine di ricerca nel valore: cardinalita'. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (a.closest('tabs-component.nav-tabs')) return;
    if (a.closest('[data-search-results], search-drawer, .search-results, [data-predictive-search]')) {
      setLastClickNav('search');
      return;
    }
    if (a.closest('header, header-component, mobile-menu, .site-navigation, .site-nav, [data-menu]')) {
      var voce = (safeText(a) || a.getAttribute('aria-label') || '').slice(0, 40);
      if (voce) setLastClickNav('menu:' + voce);
    }
  }, true);

  /* ---- Ritorno da bfcache ---------------------------------------------
     NIENTE page_view manuale: theme.liquid imposta send_page_view:false perche'
     i page_view li manda la channel app. Un nostro page_view sarebbe l'unico di
     origine diversa e farebbe un gradino in screenPageViews il giorno del
     deploy — cioe' proprio al confine della finestra prima/dopo a 28 giorni che
     il registro interventi deve valutare. Evento custom, e l'asimmetria
     impression/pagina si gestisce in analisi (o si legge da Umami).
     MAI unload/beforeunload: disattivano il bfcache. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    pageviewId = nuovoPageviewId();
    impressionTimer = {};
    send('page_restored', { page_type: getTemplate() });
  });

  /* ---- view_item_engaged ----------------------------------------------
     La visita prodotto "non rimbalzo": 20 secondi di permanenza O il primo
     gesto significativo, il primo dei due. 20 e non 10 perche' la permanenza
     mediana su una PDP supera i 10s anche per chi rimbalza: a 10s "engaged"
     sarebbe ~90% delle visite e la metrica non discriminerebbe.
     engagement_trigger permette di ricalibrare la soglia in BigQuery senza un
     redeploy del tema. Porta last_click_nav (whitelist in send()). */
  var pdpEngagedFatto = false;
  var pdpEngagedTimer = null;
  var pdpScrollHandler = null;

  function segnalaGestoPdp(trigger) {
    if (pdpEngagedFatto) return;
    if (getTemplate().indexOf('product') === -1) return;
    pdpEngagedFatto = true;
    if (pdpEngagedTimer) { clearTimeout(pdpEngagedTimer); pdpEngagedTimer = null; }
    if (pdpScrollHandler) {
      window.removeEventListener('scroll', pdpScrollHandler);
      pdpScrollHandler = null;
    }
    send('view_item_engaged', {
      engagement_trigger: trigger,
      page_type: getTemplate()
    });
  }

  (function armaEngagedPdp() {
    if (getTemplate().indexOf('product') === -1) return;
    pdpEngagedTimer = setTimeout(function () { segnalaGestoPdp('time'); }, 20000);
    pdpScrollHandler = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && (window.pageYOffset / h) > 0.25) segnalaGestoPdp('scroll');
    };
    window.addEventListener('scroll', pdpScrollHandler, { passive: true });
  })();

  /* ============================================================
     21. CONTESTO LISTA PER LE GRIGLIE SENZA CONTENITORE (nuovo, 2026-07-30)

     `select_item` e `view_item_list` si agganciano a `[data-product-list-id]`.
     Sulla home e in fondo alla scheda prodotto quel contenitore non c'e'
     (verificato: home 52 card e 0 contenitori), quindi i clic sui caroselli e
     sui correlati erano invisibili. Invece di toccare cinque file Liquid, il
     contenitore lo si deduce qui dalla sezione, una volta sola all'avvio e a
     ogni rescan.
     ============================================================ */

  function assegnaListeMancanti() {
    var candidati = document.querySelectorAll('.index-products, [data-section-type="related"], [data-related-products], .index-collections-list');
    Array.prototype.forEach.call(candidati, function (sec) {
      if (sec.hasAttribute('data-product-list-id')) return;
      if (sec.closest('[data-product-list-id]')) return;
      if (!sec.querySelector('grid-item, [data-product-id]')) return;
      var id = sec.getAttribute('data-section-id') || '';
      var modulo = moduloDiSezione(sec);
      var tipo = sec.getAttribute('data-section-type');
      var listId = tipo === 'related' ? 'pdp_related'
        : modulo === 'carosello_prodotti' ? ('home_' + (id.split('__')[1] || 'products'))
        : modulo === 'categorie' ? 'home_categorie'
        : ('sezione_' + (id.split('__')[1] || 'lista'));
      var titolo = safeText(sec.querySelector('h2, h3, .section-title, .index-products__title'));
      sec.setAttribute('data-product-list-id', listId);
      sec.setAttribute('data-product-list-name', titolo || listId);
    });
  }

  function bootstrap() {
    assegnaListeMancanti();
    scanAll();
    fireViewItem();
    /* Marca fine bootstrap dopo che l'event loop ha processato
       gli initial MutationObserver hits — evita falsi cart_drawer_open */
    setTimeout(function () { bootstrapPhase = false; }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* SINGOLO MutationObserver consolidato (fix #13) */
  var debouncedRescan = debounce(function () { assegnaListeMancanti(); scanAll(); }, 400);
  new MutationObserver(debouncedRescan).observe(document.body, { childList: true, subtree: true });

})();
